"use strict";
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createAskPassword(containerEl, deps) {
                var confirmAskPasswordAsync = deps.confirmAskPasswordAsync, sendPasswordAsync = deps.sendPasswordAsync, showLoadingDialog = deps.showLoadingDialog;
                var formEl = eXpress.html.querySelector(containerEl, ".technical-ask-password-form", true);
                var sendPassWordLinkEl = eXpress.html.querySelector(containerEl, ".technical-send-password-link", true);
                var sendPasswordLinkClick = function (e) {
                    e.preventDefault();
                    var email = sendPassWordLinkEl.dataset.email;
                    email && sendPasswordAsync(email);
                };
                var askPasswordForm = components.main.initForm(formEl, {
                    onSubmitForm: function (formData) { return showLoadingDialog ? confirmAskPasswordAsync(formData["password"]) : eXpress.utils.showLoadingDialog(confirmAskPasswordAsync(formData["password"])); },
                    submitOnEnter: true
                });
                sendPassWordLinkEl.addEventListener('click', sendPasswordLinkClick);
                return {
                    dispose: function () {
                        askPasswordForm.dispose();
                        sendPassWordLinkEl.removeEventListener('click', sendPasswordLinkClick);
                    }
                };
            }
            main.createAskPassword = createAskPassword;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createClickableElement(el, onClick, options) {
                if (options === void 0) { options = {}; }
                var clickEvent;
                var enable = options.enable, disable = options.disable;
                var onClicked = function (e) {
                    e.preventDefault();
                    if (onClick) {
                        dispose();
                        disable && disable();
                        onClick()
                            .then(function () {
                            enable && enable();
                            addClickEvent();
                        });
                    }
                };
                var addClickEvent = function () { clickEvent = eXpress.html.addEventListener(el, 'click', onClicked); };
                var dispose = function () { return clickEvent.dispose(); };
                addClickEvent();
                return {
                    addClickEvent: addClickEvent,
                    dispose: dispose
                };
            }
            main.createClickableElement = createClickableElement;
            function createButton(buttonEl, onClick) {
                var enable = function () {
                    eXpress.html.removeClass(buttonEl, "a-button--disabled");
                    buttonEl.removeAttribute("disabled");
                };
                var disable = function () {
                    eXpress.html.addClass(buttonEl, "a-button--disabled");
                    buttonEl.setAttribute("disabled", "disabled");
                };
                var button = createClickableElement(buttonEl, onClick, {
                    enable: enable,
                    disable: disable
                });
                return {
                    dispose: button.dispose,
                    enable: enable,
                    disable: disable
                };
            }
            main.createButton = createButton;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createCollapsable(container, deps) {
                var onBeforeOpen = deps.onBeforeOpen, onBeforeClose = deps.onBeforeClose, titleElSelector = deps.titleElSelector, scrollIntoViewAfterOpen = deps.scrollIntoViewAfterOpen;
                var OPEN_CLASS = "is-collapse-open";
                var titleEl = eXpress.html.querySelector(container, titleElSelector, true);
                var closeWithBefore = function () {
                    if (!onBeforeClose) {
                        close();
                        return $.Deferred().resolve().promise();
                    }
                    return onBeforeClose().then(function () { return close(); });
                };
                var openWithBefore = function (scrollIntoView) {
                    if (scrollIntoView === void 0) { scrollIntoView = false; }
                    if (!onBeforeOpen) {
                        open();
                        return $.Deferred().resolve().promise();
                    }
                    return onBeforeOpen().then(function () { return open(scrollIntoView); });
                };
                var close = function () { return container.classList.remove(OPEN_CLASS); };
                var open = function (scrollIntoView) {
                    container.classList.add(OPEN_CLASS);
                    if (scrollIntoViewAfterOpen || scrollIntoView)
                        titleEl.scrollIntoView({ behavior: "smooth", block: "start" });
                };
                var isOpen = function () { return eXpress.html.hasClass(container, OPEN_CLASS); };
                var onClick = function () { return !isOpen() ? openWithBefore() : closeWithBefore(); };
                var button = components.main.createClickableElement(titleEl, onClick);
                return {
                    dispose: button.dispose,
                    show: function () { return container.classList.remove('u-hide'); },
                    hide: function () { return container.classList.add('u-hide'); },
                    close: close,
                    open: function (scrollIntoView) { return openWithBefore(scrollIntoView); },
                    isOpen: isOpen
                };
            }
            main.createCollapsable = createCollapsable;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initCountDown(containerEl, el, countDownToDate, opts) {
                var showDays = opts.showDays, onCountDownFinish = opts.onCountDownFinish, daysLabel = opts.daysLabel, dayLabel = opts.dayLabel;
                var toDate = function (input) {
                    var dateString = input.split(' ')[0];
                    var timeString = input.split(' ')[1];
                    var day = parseInt(dateString.split('/')[0], 10);
                    var month = parseInt(dateString.split('/')[1], 10) - 1;
                    var year = parseInt(dateString.split('/')[2], 10);
                    var hour = parseInt(timeString.split(':')[0], 10);
                    var minutes = parseInt(timeString.split(':')[1], 10);
                    var seconds = parseInt(timeString.split(':')[2], 10);
                    return new Date(year, month, day, hour, minutes, seconds, 0);
                };
                var pad = function (num, size) {
                    var temp = num.toString();
                    while (temp.length < size)
                        temp = "0" + temp;
                    return temp;
                };
                var countDownTime = toDate(countDownToDate).getTime();
                var countDown = function () {
                    var now = new Date().getTime();
                    var timeLeft = countDownTime - now;
                    var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
                    if (timeLeft > 0) {
                        if (!showDays || !daysLabel || !dayLabel) {
                            hours = hours + (days * 24);
                            el.innerHTML = pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                        }
                        else {
                            if (days > 1)
                                el.innerHTML = days + ' ' + daysLabel + ' ' + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                            else if (days === 1)
                                el.innerHTML = days + ' ' + dayLabel + ' ' + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                            else
                                el.innerHTML = pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                        }
                    }
                    else {
                        if (onCountDownFinish)
                            onCountDownFinish();
                    }
                };
                setInterval(countDown, 1000);
            }
            main.initCountDown = initCountDown;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createCountrySelection(deps) {
                var onClickDisposable;
                var init = function () {
                    deps.showCountrySelectionPopup().then(function () {
                        var countrySelectionPopup = eXpress.html.querySelector(document, '#country-selection');
                        if (countrySelectionPopup) {
                            var continueButton = eXpress.html.querySelector(countrySelectionPopup, '.technical-countryselection');
                            if (continueButton) {
                                if (continueButton.dataset.countryselectionlink) {
                                    var navigateToLink_1 = continueButton.dataset.countryselectionlink.toLowerCase();
                                    attachOnClick(continueButton, function () { return navigateTo(navigateToLink_1); });
                                }
                            }
                        }
                    });
                };
                var navigateTo = function (navigateToLink) {
                    if (navigateToLink)
                        document.location.href = navigateToLink;
                    deps.close();
                };
                var attachOnClick = function (button, ev) {
                    return (onClickDisposable = eXpress.html.addEventListener(button, 'click', ev));
                };
                var detachClick = function () { return onClickDisposable && onClickDisposable.dispose(); };
                init();
                return {
                    dispose: function () {
                        detachClick();
                    }
                };
            }
            main.createCountrySelection = createCountrySelection;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            var EternalSlidingMode;
            (function (EternalSlidingMode) {
                EternalSlidingMode[EternalSlidingMode["Infinite"] = 0] = "Infinite";
                EternalSlidingMode[EternalSlidingMode["ScrollToBegin"] = 1] = "ScrollToBegin";
            })(EternalSlidingMode = main.EternalSlidingMode || (main.EternalSlidingMode = {}));
            function createCustomSlider(element, settings) {
                var sliderPxX = 0;
                var widthBeforeResize = 0;
                var sliderEl;
                var elementsEl;
                var firstVisibleElement;
                var prevButton;
                var nextButton;
                var mouseDownOnSlider = false;
                var startSliderDragX = 0;
                var startSliderDragY = 0;
                var currentSliderDragX = 0;
                var isDragged = false;
                var preventPageScrolling = false;
                var preventSliderDragging = false;
                var prevSliderWidth = 0;
                var init = function (element, replaceWithElement) {
                    if (ioSlider && !settings.forceRenderSlider) {
                        ioSlider.observe(element);
                    }
                    else {
                        sliderEl = getSliderTemplate();
                        if (replaceWithElement && element.parentElement)
                            element.parentElement.replaceChild(sliderEl, element);
                        else
                            element.appendChild(sliderEl);
                        if (settings.InitializedEvent)
                            settings.InitializedEvent(settings, sliderEl);
                        checkEdgesAndMove(0);
                        addHandlers();
                        resizeObserver.observe(elementsEl);
                    }
                };
                var dispose = function () {
                    prevButton && prevButton.removeEventListener('click', previousEvent);
                    nextButton && nextButton.removeEventListener('click', nextEvent);
                    if (sliderEl) {
                        sliderEl.removeEventListener('mousedown', function (e) {
                            e.preventDefault();
                            dragStart(e);
                        });
                        sliderEl.removeEventListener('touchstart', dragStart);
                        if (isTouchDevice()) {
                            sliderEl.removeEventListener('touchend', dragStop);
                            sliderEl.removeEventListener('touchmove', dragging);
                            sliderEl.removeEventListener('touchcancel', dragLeave);
                            return;
                        }
                        sliderEl.removeEventListener('mousemove', dragging);
                        sliderEl.removeEventListener('mouseleave', dragLeave);
                        sliderEl.removeEventListener('mouseup', dragStop);
                    }
                    if (window) {
                        window.removeEventListener('scroll', scrollStart);
                    }
                };
                var addHandlers = function () {
                    prevButton && prevButton.addEventListener('click', previousEvent);
                    nextButton && nextButton.addEventListener('click', nextEvent);
                    addSliderEventListeners();
                };
                var resizeObserver = new ResizeObserver(function (entries) {
                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                        var entry = entries_1[_i];
                        if (entry.contentRect && entry.target)
                            resize();
                    }
                });
                var isTouchDevice = function () { return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0); };
                var addSliderEventListeners = function () {
                    if (isTouchDevice())
                        sliderTouchEventListeners();
                    sliderMouseEventListeners();
                };
                var sliderMouseEventListeners = function () {
                    elementsEl.addEventListener('mousedown', function (e) {
                        e.preventDefault();
                        dragStart(e);
                    });
                };
                var sliderTouchEventListeners = function () {
                    elementsEl.addEventListener('touchstart', dragStart, { passive: true });
                    window.addEventListener('scroll', scrollStart);
                };
                var resize = function () {
                    var sliderWidth = getFullWidthElement(sliderEl);
                    if (prevSliderWidth === sliderWidth)
                        return;
                    prevSliderWidth = sliderWidth;
                    eXpress.utils.debounce(reset, 250)();
                };
                var preventClick = function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                };
                var scrollStart = function () {
                    preventSliderDragging = true;
                };
                var dragStart = function (e) {
                    var _a, _b;
                    isDragged = false;
                    mouseDownOnSlider = true;
                    startSliderDragX = getPositionX(e);
                    startSliderDragY = getPositionY(e);
                    currentSliderDragX = startSliderDragX;
                    preventPageScrolling = false;
                    preventSliderDragging =
                        ((_a = prevButton === null || prevButton === void 0 ? void 0 : prevButton.classList.contains(settings.sliderContainerSettings.previousButton.cssWhenOnMax)) !== null && _a !== void 0 ? _a : true) &&
                            ((_b = nextButton === null || nextButton === void 0 ? void 0 : nextButton.classList.contains(settings.sliderContainerSettings.nextButton.cssWhenOnMax)) !== null && _b !== void 0 ? _b : true);
                    if (isTouchDevice()) {
                        sliderEl.addEventListener('touchend', dragStop, { passive: true });
                        sliderEl.addEventListener('touchmove', eXpress.utils.throttle(dragging, 100), { passive: false });
                        sliderEl.addEventListener('touchcancel', dragLeave, { passive: true });
                        return;
                    }
                    sliderEl.addEventListener('mousemove', function (e) {
                        if (!mouseDownOnSlider)
                            return;
                        e.preventDefault();
                        dragging(e);
                    });
                    sliderEl.addEventListener('mouseleave', dragLeave, { passive: true });
                    sliderEl.addEventListener('mouseup', dragStop, { passive: true });
                };
                var dragLeave = function (e) {
                    if (!mouseDownOnSlider)
                        return;
                    mouseDownOnSlider = false;
                    elementsEl.parentElement.style.scrollBehavior = "smooth";
                    if (startSliderDragX < currentSliderDragX)
                        previousEvent(e, false, true);
                    else if (startSliderDragX > currentSliderDragX)
                        nextEvent(e, false, true);
                };
                var dragging = function (e) {
                    if (!mouseDownOnSlider || preventSliderDragging)
                        return;
                    elementsEl.parentElement.style.scrollBehavior = 'auto';
                    var posX = getPositionX(e);
                    var posY = getPositionY(e);
                    var deltaX = Math.abs(posX - startSliderDragX);
                    var deltaY = Math.abs(posY - startSliderDragY);
                    sliderPxX += Math.round(posX - currentSliderDragX);
                    if (deltaX >= deltaY) {
                        preventPageScrolling = true;
                    }
                    else {
                        return;
                    }
                    if (preventPageScrolling)
                        e.preventDefault();
                    if (settings.enableEternalSliding
                        && (settings.eternalSlidingMode || EternalSlidingMode.Infinite) === EternalSlidingMode.Infinite)
                        eXpress.utils.debounce(function (_) {
                            if (currentSliderDragX === posX || !mouseDownOnSlider)
                                return;
                            var element = getFirstVisibleElement();
                            var elementWidth = getFullWidthElement(element, true);
                            var visibleElements = Math.ceil(getFullWidthElement(sliderEl) / elementWidth);
                            var sliderxPassedTiles = -sliderPxX / elementWidth;
                            var direction = currentSliderDragX > posX ? 'left' : 'right';
                            if (direction === 'right' && (sliderxPassedTiles + visibleElements >= settings.sliderElements.length)) {
                                elementsEl.appendChild(elementsEl.children[0]);
                                sliderPxX += elementWidth;
                                moveSlider(true);
                            }
                            else if (direction === 'left' && (sliderxPassedTiles < 0.2)) {
                                elementsEl.prepend(elementsEl.children[elementsEl.children.length - 1]);
                                sliderPxX += -elementWidth;
                                moveSlider(true);
                            }
                        }, 250)();
                    currentSliderDragX = posX;
                    moveSlider(true);
                };
                var dragStop = function (e) {
                    mouseDownOnSlider = false;
                    elementsEl.parentElement.style.scrollBehavior = "smooth";
                    if (!isDragged && e.target && !e.target.classList.contains('technical-slider-button'))
                        settings.sliderContainerSettings.elementsContainerSettings.slideClicked(e, settings);
                    var slideElements = eXpress.html.querySelectorAll(elementsEl, '.technical-slider-element');
                    var elMethod = isDragged ? 'addEventListener' : 'removeEventListener';
                    slideElements.forEach(function (el) { return el[elMethod]('click', preventClick); });
                    if (startSliderDragX < currentSliderDragX)
                        previousEvent(e, false, true);
                    else if (startSliderDragX > currentSliderDragX)
                        nextEvent(e, false, true);
                    if (isTouchDevice()) {
                        sliderEl.removeEventListener('touchend', dragStop);
                        sliderEl.removeEventListener('touchmove', dragging);
                        sliderEl.removeEventListener('touchcancel', dragLeave);
                        return;
                    }
                    sliderEl.removeEventListener('mousemove', dragging);
                    sliderEl.removeEventListener('mouseleave', dragLeave);
                    sliderEl.removeEventListener('mouseup', dragStop);
                    isDragged = false;
                };
                var getPositionX = function (e) {
                    if (!e || !e.type)
                        return 0;
                    if (e.type.includes('mouse')) {
                        var mouseEvent = e;
                        return mouseEvent.pageX;
                    }
                    if (e.type.includes('touch')) {
                        var touchEvent = e;
                        return touchEvent.touches[0].pageX;
                    }
                    return 0;
                };
                var getPositionY = function (e) {
                    if (!e || !e.type)
                        return 0;
                    if (e.type.includes('mouse')) {
                        var mouseEvent = e;
                        return mouseEvent.pageY;
                    }
                    if (e.type.includes('touch')) {
                        var touchEvent = e;
                        return touchEvent.touches[0].pageY;
                    }
                    return 0;
                };
                var getSliderTemplate = function () {
                    settings.sliderElements = settings.sliderElements.filter(function (el) { return el.template && !el.template.classList.contains("technical-slider-button"); });
                    if (settings.sliderElements.length === 0)
                        return document.createElement('span');
                    var div = document.createElement('div');
                    div.className += settings.sliderContainerSettings.extraSliderClass;
                    var temp = eXpress.html.querySelector(element, ".technical-slider-prev-button");
                    if (temp)
                        prevButton = temp;
                    prevButton && div.appendChild(prevButton);
                    temp = eXpress.html.querySelector(element, ".technical-slider-elements");
                    if (temp)
                        elementsEl = temp;
                    else
                        elementsEl = document.createElement('div');
                    elementsEl.className += settings.sliderContainerSettings.elementsContainerSettings.extraSliderClass;
                    elementsEl.classList.add('technical-slider-elements');
                    for (var i = 0, l = settings.sliderElements.length; i < l; i++) {
                        var customPhotoSliderItem = settings.sliderElements[i];
                        var sliderElementDiv = createSliderElement(customPhotoSliderItem);
                        elementsEl.appendChild(sliderElementDiv);
                    }
                    div.appendChild(elementsEl);
                    temp = eXpress.html.querySelector(element, ".technical-slider-next-button");
                    if (temp)
                        nextButton = temp;
                    nextButton && div.appendChild(nextButton);
                    settings.SliderCreated && settings.SliderCreated(settings, div, sliderEl);
                    return div;
                };
                var getCurrentElement = function () {
                    var elementEl = getFirstVisibleElement();
                    if (!elementEl)
                        return;
                    var elementElWidth = getFullWidthElement(elementEl, true);
                    var currentElementIndex = elementElWidth <= 0 ? 0 : Math.floor(Math.abs(sliderPxX) / elementElWidth);
                    var index = currentElementIndex % elementsEl.children.length;
                    return settings.sliderElements.find(function (x) { return elementsEl.children[index].id === x.id; });
                };
                var getAllElements = function () {
                    var slides = Array.from(elementsEl.children);
                    return __spreadArray([], settings.sliderElements, true).sort(function (a, b) {
                        var elementA = slides.find(function (e) { return e.id === a.id; });
                        var elementB = slides.find(function (e) { return e.id === b.id; });
                        return slides.indexOf(elementA) - slides.indexOf(elementB);
                    });
                };
                var resizeSliderElementsToFullWidth = function () {
                    var element = getFirstVisibleElement();
                    if (!element || !element.parentElement || element.clientWidth <= 0)
                        return;
                    var widthAfterResize = getFullWidthElement(element.parentElement);
                    if (widthBeforeResize === widthAfterResize)
                        return;
                    for (var i = 0; i < elementsEl.children.length; i++) {
                        var slide = elementsEl.children[i];
                        slide.style.width = "".concat(widthAfterResize, "px");
                        slide.style.minWidth = "".concat(widthAfterResize, "px");
                        slide.style.maxWidth = "".concat(widthAfterResize, "px");
                    }
                    if (widthBeforeResize > 0) {
                        var amountOfSlides = Math.abs(Math.ceil(sliderPxX / widthBeforeResize));
                        sliderPxX = sliderPxX - ((widthAfterResize - widthBeforeResize) * amountOfSlides);
                    }
                    widthBeforeResize = widthAfterResize;
                };
                var checkEdgesAndMove = function (movePx, draggedSlider, jumpIntoView) {
                    if (jumpIntoView === void 0) { jumpIntoView = false; }
                    sliderPxX += movePx;
                    var prevButtonClasslistMethod = 'add';
                    var nextButtonClasslistMethod = 'add';
                    var element = getFirstVisibleElement();
                    var elementWidth = getFullWidthElement(element, true);
                    var moveToOtherside = false;
                    var endOfSlider = function () { return getFullWidthElement(sliderEl) - (elementWidth * settings.sliderElements.length); };
                    var widthRightSidePx = function () { return (elementWidth * settings.sliderElements.length) - Math.abs(sliderPxX); };
                    if (sliderPxX >= 0) {
                        nextButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding)
                            prevButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding && !jumpIntoView && sliderPxX > 0) {
                            switch (settings.eternalSlidingMode) {
                                case EternalSlidingMode.ScrollToBegin:
                                    moveToOtherside = true;
                                    sliderPxX = endOfSlider();
                                    break;
                                case EternalSlidingMode.Infinite:
                                default:
                                    elementsEl.prepend(elementsEl.children[elementsEl.children.length - 1]);
                                    moveSlider(true, false, -sliderPxX);
                                    sliderPxX = 0;
                                    break;
                            }
                        }
                        else
                            sliderPxX = 0;
                    }
                    else if (widthRightSidePx() <= getFullWidthElement(sliderEl)) {
                        prevButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding)
                            nextButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding && !jumpIntoView && widthRightSidePx() < getFullWidthElement(sliderEl)) {
                            switch (settings.eternalSlidingMode) {
                                case EternalSlidingMode.ScrollToBegin:
                                    moveToOtherside = true;
                                    sliderPxX = 0;
                                    break;
                                case EternalSlidingMode.Infinite:
                                default:
                                    if (elementWidth <= 0)
                                        break;
                                    do {
                                        elementsEl.appendChild(elementsEl.children[0]);
                                        moveSlider(true, false, sliderPxX + Math.abs(movePx) + elementWidth);
                                        sliderPxX += elementWidth;
                                    } while (widthRightSidePx() < getFullWidthElement(sliderEl));
                                    break;
                            }
                        }
                        else
                            sliderPxX = endOfSlider();
                    }
                    else {
                        prevButtonClasslistMethod = 'remove';
                        nextButtonClasslistMethod = 'remove';
                    }
                    if (getFullWidthElement(sliderEl) >= (getFullWidthElement(element, true) * settings.sliderElements.length)) {
                        nextButtonClasslistMethod = 'add';
                        prevButtonClasslistMethod = 'add';
                    }
                    if (settings.sliderContainerSettings.cssWhenButtonsBothOnMax) {
                        if (prevButton)
                            prevButton.classList.toggle(settings.sliderContainerSettings.cssWhenButtonsBothOnMax, nextButtonClasslistMethod === 'add' && prevButtonClasslistMethod === 'add');
                        if (nextButton)
                            nextButton.classList.toggle(settings.sliderContainerSettings.cssWhenButtonsBothOnMax, nextButtonClasslistMethod === 'add' && prevButtonClasslistMethod === 'add');
                    }
                    if (prevButton)
                        prevButton.classList[prevButtonClasslistMethod](settings.sliderContainerSettings.previousButton.cssWhenOnMax);
                    if (nextButton)
                        nextButton.classList[nextButtonClasslistMethod](settings.sliderContainerSettings.nextButton.cssWhenOnMax);
                    if (prevButton || nextButton)
                        moveSlider(draggedSlider, moveToOtherside);
                };
                var moveSlider = function (draggedSlider, moveToOtherside, sliderPxXOverride) {
                    if (moveToOtherside === void 0) { moveToOtherside = false; }
                    var ms = moveToOtherside ? elementsEl.children.length * 250 : 200;
                    elementsEl.style.transition = draggedSlider ? 'none' : "all ".concat(ms, "ms ease-in-out 0s");
                    var pixelX = sliderPxXOverride || sliderPxXOverride >= 0 ? sliderPxXOverride : sliderPxX;
                    if (settings.translateForMovement) {
                        elementsEl.style.transform = "translateX(".concat(pixelX, "px)");
                    }
                    else {
                        elementsEl.parentElement && elementsEl.parentElement.scroll({
                            top: 0,
                            left: -pixelX,
                            behavior: draggedSlider ? 'instant' : 'smooth'
                        });
                    }
                };
                var createSliderElement = function (customPhotoSliderItem) {
                    if (!customPhotoSliderItem.id)
                        customPhotoSliderItem.id = eXpress.utils.newSliderGuid();
                    var sliderElement = customPhotoSliderItem.template ? customPhotoSliderItem.template.cloneNode(true) : document.createElement('div');
                    sliderElement.id = customPhotoSliderItem.id;
                    sliderElement.classList.add('technical-slider-element');
                    return sliderElement;
                };
                var removeImageFromArray = function (indexToRemove) {
                    if (!settings.sliderElements || indexToRemove > settings.sliderElements.length - 1 || indexToRemove < 0 || !settings.sliderElements[indexToRemove])
                        throw Error('Something is wrong with your current parameters');
                    else {
                        var tempArray = settings.sliderElements.slice(0, indexToRemove);
                        if (tempArray.length === settings.sliderElements.length - 1) {
                            settings.sliderElements = tempArray;
                            return;
                        }
                        tempArray = tempArray.concat(settings.sliderElements.slice(indexToRemove + 1));
                        settings.sliderElements = tempArray;
                    }
                };
                var insertIntoSliderElements = function (sliderElement, indexToInsert) {
                    if (indexToInsert === settings.sliderElements.length) {
                        settings.sliderElements.push(sliderElement);
                        return;
                    }
                    if (indexToInsert === 0) {
                        var tempArray_1 = [sliderElement];
                        settings.sliderElements = tempArray_1.concat(settings.sliderElements);
                        return;
                    }
                    var tempArray = settings.sliderElements.slice(0, indexToInsert);
                    tempArray.push(sliderElement);
                    tempArray = tempArray.concat(settings.sliderElements.slice(indexToInsert));
                    settings.sliderElements = tempArray;
                };
                var calculateNextMove = function (positiveMove) {
                    var elementEl = getFirstVisibleElement();
                    if (settings.sliderElements.length <= 1 || !elementEl)
                        return 0;
                    var elementElWidth = getFullWidthElement(elementEl, true);
                    if (Math.ceil(getFullWidthElement(elementsEl)) / elementElWidth < 1)
                        return elementElWidth * (positiveMove ? -0.5 : 0.5);
                    var pxRight = (elementElWidth * settings.sliderElements.length) - (Math.ceil(getFullWidthElement(sliderEl)) + Math.abs(sliderPxX));
                    var maxPossibleSliderItemsRightPx = pxRight / elementElWidth;
                    var maxPossibleSliderItemsLeftpx = Math.abs(sliderPxX) / elementElWidth;
                    var percentage = positiveMove
                        ? (settings.eternalSlidingMode || EternalSlidingMode.Infinite) == EternalSlidingMode.Infinite ? (maxPossibleSliderItemsLeftpx - Math.floor(maxPossibleSliderItemsLeftpx)) - 1 : -(maxPossibleSliderItemsRightPx - Math.floor(maxPossibleSliderItemsRightPx))
                        : maxPossibleSliderItemsLeftpx - Math.floor(maxPossibleSliderItemsLeftpx);
                    percentage = parseInt("".concat(percentage * 10000)) / 10000;
                    if (percentage === 0 || Math.abs(percentage) <= 0.08)
                        percentage += positiveMove ? -1 : 1;
                    if (settings.showHalfSlides)
                        percentage *= 1.5;
                    return elementElWidth * percentage;
                };
                var jumpIntoView = function (sliderElement, smoothSlideIntoView, align) {
                    if (smoothSlideIntoView === void 0) { smoothSlideIntoView = true; }
                    if (align === void 0) { align = 'start'; }
                    var elements = getAllElements();
                    var indexOfElement = elements.indexOf(sliderElement);
                    if (indexOfElement < 0)
                        return;
                    var visibleEl = getFirstVisibleElement();
                    var element = eXpress.html.querySelector(elementsEl, "#".concat(visibleEl.id), true);
                    var elementWidth = getFullWidthElement(element, true);
                    var moveToLocation;
                    switch (settings.eternalSlidingMode) {
                        case EternalSlidingMode.ScrollToBegin:
                            moveToLocation = (elementWidth * indexOfElement) - (align == 'start' ? 0 : (elementWidth * ((getFullWidthElement(sliderEl) / elementWidth) - 1)));
                            break;
                        case EternalSlidingMode.Infinite:
                        default: {
                            var currentSlide = getCurrentElement();
                            var currentSlideIndex = elements.indexOf(currentSlide);
                            var visibleElements = Math.ceil(getFullWidthElement(sliderEl) / elementWidth);
                            switch (align) {
                                case 'start':
                                    {
                                        if (currentSlideIndex > indexOfElement)
                                            break;
                                        var elementsToMoveToFront = __spreadArray([], elements, true).splice(currentSlideIndex + visibleElements);
                                        elementsToMoveToFront.forEach(function (_, i) {
                                            elementsEl.prepend(elementsEl.children[elementsEl.children.length - 1]);
                                            sliderPxX -= elementWidth;
                                            moveSlider(true, false);
                                        });
                                        break;
                                    }
                                case 'end':
                                default:
                                    {
                                        if (currentSlideIndex < indexOfElement)
                                            break;
                                        var elementsToMoveToBack = __spreadArray([], elements, true).splice(currentSlideIndex);
                                        elementsToMoveToBack.forEach(function (_, i) {
                                            elementsEl.appendChild(elementsEl.children[0]);
                                            sliderPxX += elementWidth;
                                            moveSlider(true, false);
                                        });
                                        break;
                                    }
                            }
                            indexOfElement = getAllElements().indexOf(sliderElement);
                            moveToLocation = (elementWidth * indexOfElement) - (align == 'start' ? 0 : (elementWidth * ((getFullWidthElement(sliderEl) / elementWidth) - 1)));
                            break;
                        }
                    }
                    var movePx = moveToLocation > Math.abs(sliderPxX) ? -moveToLocation - sliderPxX : Math.abs(sliderPxX) - moveToLocation;
                    checkEdgesAndMove(movePx, !smoothSlideIntoView, true);
                };
                var getFirstVisibleElement = function () {
                    if (!elementsEl)
                        return;
                    if (firstVisibleElement)
                        return firstVisibleElement;
                    for (var i = 0; i < elementsEl.children.length; i++) {
                        var element_1 = elementsEl.children[i];
                        if (element_1 && element_1.id) {
                            var htmlElement = eXpress.html.querySelector(elementsEl, "#".concat(element_1.id), true);
                            if (getFullWidthElement(htmlElement) > 0 && htmlElement.clientWidth > 0) {
                                firstVisibleElement = htmlElement;
                                return htmlElement;
                            }
                        }
                    }
                    return undefined;
                };
                var getFullWidthElement = function (element, isSliderElement) {
                    if (isSliderElement === void 0) { isSliderElement = false; }
                    if (!element)
                        return 0;
                    var style = window.getComputedStyle(element), width = style.width ? parseFloat(style.width) ? parseFloat(style.width) : element.clientWidth : element.clientWidth, margin = parseFloat(style.marginLeft ? style.marginLeft : '0') + parseFloat(style.marginRight ? style.marginRight : '0'), padding = parseFloat(style.paddingLeft ? style.paddingLeft : '0') + parseFloat(style.paddingRight ? style.paddingRight : '0');
                    return Math.ceil((width + (margin ? margin : 0) + (padding ? padding : 0)) + (isSliderElement ? parseFloat(window.getComputedStyle(elementsEl).gap || '0') || 0 : 0));
                };
                var removeSliderElement = function (sliderElement, indexToRemove) {
                    if ((!indexToRemove && settings.sliderElements.filter(function (x) { return x.id === sliderElement; }).length < 0) || (indexToRemove && (indexToRemove < 0 || indexToRemove > settings.sliderElements.length - 1)))
                        throw Error('Index to remove not found');
                    removeImageFromArray(indexToRemove ? indexToRemove : settings.sliderElements.indexOf(sliderElement));
                    firstVisibleElement = undefined;
                    if (!sliderElement.id)
                        throw Error('invalid image id');
                    var deleteImageEl = eXpress.html.querySelector(elementsEl, "#".concat(sliderElement.id), true);
                    elementsEl.removeChild(deleteImageEl);
                    checkEdgesAndMove(0);
                };
                var removeSliderElementOnIndex = function (indexToRemove) {
                    if ((indexToRemove < 0 || indexToRemove > settings.sliderElements.length - 1))
                        throw Error('Index to remove not found');
                    var deletedElement = settings.sliderElements[indexToRemove];
                    removeSliderElement(deletedElement, indexToRemove);
                };
                var addSliderElement = function (sliderElement, indexToInsert) {
                    if (indexToInsert === void 0) { indexToInsert = settings.sliderElements.length; }
                    if (!sliderElement.id || settings.sliderElements.find(function (x) { return x.id === sliderElement.id; }))
                        sliderElement.id = eXpress.utils.newSliderGuid();
                    var element = indexToInsert === settings.sliderElements.length
                        ? settings.sliderElements[settings.sliderElements.length - 1]
                        : settings.sliderElements[indexToInsert];
                    insertIntoSliderElements(sliderElement, indexToInsert);
                    var prevElement = eXpress.html.querySelector(elementsEl, "#".concat(element.id), true);
                    var newSlideElement = createSliderElement(sliderElement);
                    indexToInsert === settings.sliderElements.length
                        ? elementsEl.insertAdjacentElement("afterend", newSlideElement)
                        : elementsEl.insertBefore(newSlideElement, prevElement);
                    jumpIntoView(sliderElement);
                };
                var reset = function () {
                    if (settings.resize1SlideToFullWidth)
                        resizeSliderElementsToFullWidth();
                    settings.BeforeResizeEvent && settings.BeforeResizeEvent(settings, sliderEl);
                    checkEdgesAndMove(0);
                    settings.ResizeEvent && settings.ResizeEvent(settings, sliderEl);
                };
                var previousEvent = function (e, draggedSlider, draggedSliderEventTracking) {
                    if (draggedSlider === void 0) { draggedSlider = false; }
                    if (draggedSliderEventTracking === void 0) { draggedSliderEventTracking = false; }
                    if (!settings.enableEternalSliding)
                        checkEdgesAndMove(0);
                    if (prevButton && prevButton.classList.contains(settings.sliderContainerSettings.previousButton.cssWhenOnMax))
                        return;
                    var nextMove = calculateNextMove(false);
                    checkEdgesAndMove(nextMove, draggedSlider);
                    settings.sliderContainerSettings.previousButton.onClick(e, draggedSliderEventTracking);
                };
                var nextEvent = function (e, draggedSlider, draggedSliderEventTracking) {
                    if (draggedSlider === void 0) { draggedSlider = false; }
                    if (draggedSliderEventTracking === void 0) { draggedSliderEventTracking = false; }
                    if (!settings.enableEternalSliding)
                        checkEdgesAndMove(0);
                    if (nextButton && nextButton.classList.contains(settings.sliderContainerSettings.nextButton.cssWhenOnMax))
                        return;
                    var nextMove = calculateNextMove(true);
                    checkEdgesAndMove(nextMove, draggedSlider);
                    settings.sliderContainerSettings.nextButton.onClick(e, draggedSliderEventTracking);
                };
                var createIntersectionObserver = function () {
                    if (('InterSectionObserver' in window || 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        return new IntersectionObserver(function (entries, observer) {
                            entries.forEach(function (entry) {
                                if (entry.isIntersecting && entry.target.classList.contains(element.classList[0])) {
                                    ioSlider = undefined;
                                    init(element, settings.replaceWithElement);
                                    observer.unobserve(entry.target);
                                }
                            });
                        }, { rootMargin: "0px 0px 0px 0px" });
                    }
                };
                var showButtons = function () {
                    nextButton && eXpress.html.removeClass(nextButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                    prevButton && eXpress.html.removeClass(prevButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                };
                var hideButtons = function () {
                    nextButton && eXpress.html.addClass(nextButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                    prevButton && eXpress.html.addClass(prevButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                };
                var ioSlider = createIntersectionObserver();
                init(element, settings.replaceWithElement);
                return {
                    RemoveSliderElement: removeSliderElement,
                    RemoveSliderElementOnIndex: removeSliderElementOnIndex,
                    AddSliderElement: addSliderElement,
                    Previous: previousEvent,
                    Next: nextEvent,
                    JumpIntoView: jumpIntoView,
                    Settings: settings,
                    GetCurrentSlide: getCurrentElement,
                    GetAllSlides: getAllElements,
                    GetSliderElement: function () { return sliderEl; },
                    ShowButtons: showButtons,
                    HideButtons: hideButtons,
                    Dispose: dispose,
                    AddHandlers: addHandlers
                };
            }
            main.createCustomSlider = createCustomSlider;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            var ExternalLoginProvider;
            (function (ExternalLoginProvider) {
                ExternalLoginProvider[ExternalLoginProvider["Google"] = 0] = "Google";
                ExternalLoginProvider[ExternalLoginProvider["Facebook"] = 1] = "Facebook";
            })(ExternalLoginProvider || (ExternalLoginProvider = {}));
            var signInButtons = [];
            var enableButton = function (button) {
                button.enable();
                var item = signInButtons.filter(function (b) { return b.Button == button; })[0];
                item && item.ButtonEl.classList.remove('skeleton-loading');
            };
            function createGoogleLogin(googleLoginButtonEl, onOrderFlow, deps) {
                var _this = this;
                var handleExternalLoginResult = deps.handleExternalLoginResult;
                var googleButton = components.main.createButton(googleLoginButtonEl);
                signInButtons.push({ Provider: ExternalLoginProvider.Google, ButtonEl: googleLoginButtonEl, Button: googleButton });
                var initClient = function () {
                    if (typeof (google) === "undefined") {
                        setTimeout(initClient, 50);
                        return;
                    }
                    var clientId = googleLoginButtonEl.dataset.appid || '';
                    var scope = googleLoginButtonEl.dataset.scope;
                    google.accounts.id.initialize({
                        client_id: clientId,
                        use_fedcm_for_button: true,
                        callback: function (response) { return __awaiter(_this, void 0, void 0, function () {
                            var body;
                            return __generator(this, function (_a) {
                                body = {
                                    jwtToken: response.credential,
                                    onOrderFlow: onOrderFlow,
                                    scope: scope
                                };
                                $.ajax({
                                    url: '/ajaxxhr/Login/LoginWithGoogle',
                                    type: 'POST',
                                    global: false,
                                    contentType: 'application/json; charset=utf-8',
                                    data: JSON.stringify(body),
                                    dataType: 'json'
                                }).then(function (res) {
                                    handleExternalLoginResult(res, "googlephotos", false, onOrderFlow, response.credential, scope);
                                });
                                return [2];
                            });
                        }); },
                    });
                    google.accounts.id.renderButton(googleLoginButtonEl, {
                        type: 'standard',
                        shape: "rectangular",
                        size: 'large',
                        width: 250,
                        locale: window.context.locale,
                    });
                    enableButton(googleButton);
                };
                var googleScriptSrc = 'https://accounts.google.com/gsi/client?hl=' + window.context.language;
                var scripts = document.getElementsByTagName('script');
                for (var _i = 0, _a = scripts; _i < _a.length; _i++) {
                    var item = _a[_i];
                    if (item.src === googleScriptSrc) {
                        initClient();
                        return;
                    }
                }
                var scriptEl = document.createElement('script');
                scriptEl.type = 'text/javascript';
                scriptEl.async = true;
                scriptEl.defer = true;
                scriptEl.onload = initClient;
                scriptEl.src = googleScriptSrc;
                var firstScriptEl = document.getElementsByTagName('script')[0];
                firstScriptEl.parentElement.insertBefore(scriptEl, firstScriptEl);
            }
            main.createGoogleLogin = createGoogleLogin;
            function createFacebookLoginButton(facebookButtonEl, onOrderFlow, deps) {
                var handleExternalLoginResult = deps.handleExternalLoginResult;
                var disposableEvent;
                var isFacebookInitialized = false;
                var facebookButton = components.main.createButton(facebookButtonEl);
                signInButtons.push({ Provider: ExternalLoginProvider.Facebook, ButtonEl: facebookButtonEl, Button: facebookButton });
                var onClick = function (ev) {
                    var _a;
                    if (ev.preventDefault) {
                        ev.preventDefault();
                    }
                    ev.stopPropagation();
                    facebookButton.disable();
                    var scopes = (_a = facebookButtonEl.dataset.scope) !== null && _a !== void 0 ? _a : '';
                    loginToFacebook(scopes, false, onOrderFlow);
                };
                var init = function () {
                    if (typeof (FB) === "undefined")
                        return;
                    if (!isFacebookInitialized) {
                        var appId = facebookButtonEl.dataset.appid ? facebookButtonEl.dataset.appid : '';
                        initFacebook(appId);
                    }
                    disposableEvent = eXpress.html.addEventListener(facebookButtonEl, 'click', onClick);
                    enableButton(facebookButton);
                };
                var initFacebook = function (appId) {
                    FB.init({ appId: appId, status: false, cookie: true, version: 'v22.0' });
                    isFacebookInitialized = true;
                    eXpress.html.show(facebookButtonEl);
                };
                var loginToFacebook = function (requestedScopes, skipLogin, onOrderFlow) {
                    if (typeof (FB) === "undefined")
                        return;
                    if (skipLogin === null)
                        skipLogin = false;
                    FB.login(function (loginResponse) {
                        var _this = this;
                        if (!loginResponse ||
                            loginResponse.status !== "connected" ||
                            !loginResponse.authResponse ||
                            !loginResponse.authResponse.userID)
                            return enableButton(facebookButton);
                        var uid = loginResponse.authResponse.userID;
                        FB.api("/" + uid + "/permissions", function (response) { return __awaiter(_this, void 0, void 0, function () {
                            var accessToken, scopes, expiresIn, body;
                            return __generator(this, function (_a) {
                                if (!response || !response.data || response.data.length == 0)
                                    return [2, enableButton(facebookButton)];
                                if (!checkFacebookPermissions(requestedScopes, response.data))
                                    return [2, enableButton(facebookButton)];
                                accessToken = loginResponse.authResponse.accessToken;
                                scopes = response.data.map(function (scope) { return (scope.status == "granted" ? scope.permission : ""); });
                                expiresIn = loginResponse.authResponse.expiresIn;
                                body = {
                                    userId: uid,
                                    accessToken: accessToken,
                                    expiresIn: expiresIn,
                                    scopes: scopes,
                                    onOrderFlow: onOrderFlow,
                                };
                                $.ajax({
                                    url: '/ajaxxhr/Login/LoginWithFacebook',
                                    type: 'POST',
                                    global: false,
                                    contentType: 'application/json; charset=utf-8',
                                    data: JSON.stringify(body),
                                    dataType: 'json'
                                }).then(function (res) {
                                    handleExternalLoginResult(res, "facebook", false, onOrderFlow, uid, accessToken, scopes.join(" "), expiresIn);
                                }).always(function () { enableButton(facebookButton); });
                                return [2];
                            });
                        }); });
                    }, { scope: requestedScopes, auth_type: "rerequest" });
                };
                var checkFacebookPermissions = function (requestedScopes, data) {
                    if (!data)
                        return false;
                    if (!requestedScopes)
                        return false;
                    var requestedScopesArr = requestedScopes.split(" ");
                    var grantedScopes = data.filter(function (e) { return e.status === "granted"; }).map(function (e) { return e.permission; });
                    var allowedScopes = grantedScopes.filter(function (grantedScope) { return requestedScopesArr.includes(grantedScope); });
                    return allowedScopes.length == requestedScopesArr.length;
                };
                var deInit = function () { return disposableEvent && disposableEvent.dispose(); };
                init();
                return {
                    dispose: deInit,
                };
            }
            main.createFacebookLoginButton = createFacebookLoginButton;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createForgotPassword(containerEl, deps) {
                var confirmForgotPasswordAsync = deps.confirmForgotPasswordAsync;
                var formEl = eXpress.html.querySelector(containerEl, ".technical-forgot-password-form", true);
                var forgotPasswordForm = components.main.initForm(formEl, {
                    onSubmitForm: function (formData) { return confirmForgotPasswordAsync(formData["email"]); },
                    submitOnEnter: true
                });
                return {
                    dispose: function () {
                        forgotPasswordForm.dispose();
                    }
                };
            }
            main.createForgotPassword = createForgotPassword;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createBaseFormInput(containerEl, altSelector) {
                var inputEl = eXpress.html.querySelector(containerEl, altSelector || ".a-form-input__input", true);
                var errorParagraphEl = eXpress.html.querySelector(containerEl, '.a-form-input__error-text');
                var toggleAttribute = function (attr, force) { return inputEl.toggleAttribute(attr, force); };
                var toggleEnable = function (enable) {
                    toggleAttribute('disabled', !enable);
                    eXpress.html.toggleClass(containerEl, 'a-form-input--disabled', !enable);
                };
                var clear = function (clearValue) {
                    if (clearValue === void 0) { clearValue = false; }
                    clearValue && (inputEl.value = '');
                    containerEl.classList.remove("a-form-input--validated");
                    containerEl.classList.remove("a-form-input--error");
                };
                var setError = function (error, doClear) {
                    if (doClear === void 0) { doClear = false; }
                    doClear && clear();
                    containerEl.classList.remove("a-form-input--validated");
                    containerEl.classList.add("a-form-input--error");
                    errorParagraphEl && (errorParagraphEl.innerHTML = error);
                };
                var setRequired = function (value) {
                    inputEl.required = value;
                };
                return {
                    clear: clear,
                    setError: setError,
                    enable: function () { return toggleEnable(true); },
                    disable: function () { return toggleEnable(false); },
                    inputEl: inputEl,
                    show: function () { return containerEl.classList.remove('u-hide'); },
                    hide: function () { return containerEl.classList.add('u-hide'); },
                    setRequired: setRequired
                };
            }
            main.createBaseFormInput = createBaseFormInput;
            function createCheckBox(containerEl, onChange, altSelector) {
                var input = createFormInput(containerEl, altSelector);
                var event;
                onChange && (event = eXpress.html.addEventListener(input.inputEl, "change", function () { return onChange(!!input.getValue()); }));
                return __assign(__assign({}, input), { dispose: function () { return event && event.dispose; } });
            }
            main.createCheckBox = createCheckBox;
            function createSelectBox(containerEl, onSelected) {
                var baseComponent = createBaseFormInput(containerEl);
                var selectEl = baseComponent.inputEl;
                var setValue = function (value) { return (selectEl.value = value); };
                var onSelect = function () { return onSelected && onSelected(selectEl.value); };
                var disposableEvent = eXpress.html.addEventListener(selectEl, 'change', onSelect);
                return __assign(__assign({}, baseComponent), { dispose: disposableEvent.dispose, inputEl: selectEl, setValue: setValue, getValue: function () { return selectEl.value; } });
            }
            main.createSelectBox = createSelectBox;
            function createHiddenFormInput(el) {
                var inputEl = el;
                var getValue = function () { return inputEl.value; };
                var setValue = function (value) {
                    el.value = value;
                };
                var clear = function (clearValue) {
                    clearValue && (inputEl.value = '');
                };
                var setError = function (error, doClear) {
                    if (doClear) {
                        clear();
                    }
                };
                var hide = function () {
                    return;
                };
                var show = function () {
                    return;
                };
                var setRequired = function (value) {
                    return;
                };
                var enable = function () {
                    return;
                };
                var disable = function () {
                    return;
                };
                return {
                    inputEl: inputEl,
                    setValue: setValue,
                    getValue: getValue,
                    clear: clear,
                    setError: setError,
                    hide: hide,
                    show: show,
                    setRequired: setRequired,
                    enable: enable,
                    disable: disable
                };
            }
            main.createHiddenFormInput = createHiddenFormInput;
            function createFormInput(containerEl, altSelector) {
                var baseComponent = createBaseFormInput(containerEl, altSelector);
                var inputEl = baseComponent.inputEl;
                var isCheckBox = inputEl.type.toLowerCase() === 'checkbox';
                var setValue = function (value) {
                    return isCheckBox
                        ? inputEl.checked = value.toString().toLowerCase() === "true"
                        : (inputEl.value = value.toString());
                };
                inputEl.addEventListener('focusout', function () {
                    var formatExample = inputEl.getAttribute('format-example');
                    var regex = inputEl.getAttribute('regex');
                    if (!formatExample || !inputEl.value || (regex && new RegExp(regex).test(inputEl.value)) || (formatExample && regex && !new RegExp(regex).test(formatExample)))
                        return;
                    inputEl.value = inputEl.value.trim();
                    var spaceIndex = formatExample.indexOf(' ');
                    while (spaceIndex >= 0 && spaceIndex <= inputEl.value.length - 1) {
                        if (inputEl.value[spaceIndex] !== ' ')
                            inputEl.value = inputEl.value.slice(0, spaceIndex) + ' ' + inputEl.value.slice(spaceIndex);
                        spaceIndex = formatExample.indexOf(' ', spaceIndex + 1);
                    }
                });
                var getValue = function () {
                    return isCheckBox
                        ? inputEl.checked
                        : inputEl.value;
                };
                if (inputEl.type.toLowerCase() === 'text' && inputEl.inputMode.toLowerCase() == 'tel' && inputEl.getAttribute('countrycode')) {
                    var countryCode_1 = inputEl.getAttribute('countrycode');
                    var togglePhoneNumberPrefix_1 = function (element, inFocus) {
                        if (!inFocus)
                            element.value = element.value.replace(/\s/g, '');
                        if (element.value === eXpress.utils.FillPhoneWithCountryPrefixWhenEmpty(countryCode_1) || !element.value)
                            element.value = inFocus ? eXpress.utils.FillPhoneWithCountryPrefixWhenEmpty(countryCode_1) : '';
                    };
                    inputEl.addEventListener('focusout', function () { return togglePhoneNumberPrefix_1(inputEl, false); });
                    inputEl.addEventListener('focusin', function () { return togglePhoneNumberPrefix_1(inputEl, true); });
                }
                return __assign(__assign({ setValue: setValue, getValue: getValue }, baseComponent), { inputEl: inputEl });
            }
            main.createFormInput = createFormInput;
            function createPasswordFormInput(containerEl) {
                var formInput = createFormInput(containerEl);
                var iconEl = eXpress.html.querySelector(containerEl, ".technical-password-unhide-icon", false);
                var disposableEvent;
                var validatePassword = function () {
                    var value = formInput.inputEl.value;
                    formInput.inputEl.dataset["lastvalidatedpassword"] = '';
                    formInput.inputEl.dataset["lastvalidatedresult"] = '';
                    return !value || value.length < Number.parseInt(formInput.inputEl.dataset.minlength || "6", 10)
                        ? $.Deferred().resolve(true).promise()
                        : formInput.inputEl.hasAttribute("data-pristine-strongpassword") &&
                            formInput.inputEl.dataset.pristineStrongpassword === "true"
                            ? $.ajax({
                                url: "/ajaxxhr/Login/ValidatePassword",
                                method: 'POST',
                                data: {
                                    password: eXpress.utils.stringToBase64(formInput.inputEl.value),
                                }
                            }).then(function (res) {
                                formInput.inputEl.dataset["lastvalidatedpassword"] = value;
                                formInput.inputEl.dataset["lastvalidatedresult"] = "".concat(res.isValid);
                                !res.isValid && formInput.setError(res.Label);
                                return res.isValid;
                            })
                            : $.Deferred().resolve(true).promise();
                };
                var onPasswordShowHideIconClick = function () {
                    switch (formInput.inputEl.getAttribute("type")) {
                        case "password":
                            formInput.inputEl.setAttribute("type", "text");
                            if (iconEl)
                                iconEl.classList.add("a-form-input__password-unhide-icon--hide");
                            break;
                        case "text":
                            formInput.inputEl.setAttribute("type", "password");
                            if (iconEl)
                                iconEl.classList.remove("a-form-input__password-unhide-icon--hide");
                            break;
                        default:
                            break;
                    }
                };
                var disable = function () {
                    formInput.disable();
                    if (iconEl) {
                        iconEl.style.cursor = 'not-allowed';
                        dispose();
                    }
                };
                var enable = function () {
                    formInput.enable();
                    if (iconEl) {
                        iconEl.style.cursor = 'pointer';
                        addEvent();
                    }
                };
                var dispose = function () { if (disposableEvent)
                    disposableEvent.dispose(); };
                var addEvent = function () { return (disposableEvent = iconEl ? eXpress.html.addEventListener(iconEl, 'click', onPasswordShowHideIconClick) : null); };
                if (iconEl)
                    addEvent();
                return __assign(__assign({ validatePassword: validatePassword }, formInput), { disable: disable, enable: enable });
            }
            main.createPasswordFormInput = createPasswordFormInput;
            function createTextInputWithAutoComplete(inputEl, deps) {
                inputEl.setAttribute('autocomplete', 'off');
                var autoCompleteSearch = deps.autoCompleteSearch, onSelect = deps.onSelect, customize = deps.customize, onOpen = deps.onOpen, onClose = deps.onClose, renderTextContent = deps.renderTextContent, _a = deps.debounceWaitMs, debounceWaitMs = _a === void 0 ? 250 : _a, _b = deps.containerInsertPosition, containerInsertPosition = _b === void 0 ? 'beforeend' : _b, _c = deps.containerClass, containerClass = _c === void 0 ? 'm-autocomplete a-form-input__autocomplete' : _c, _d = deps.disableAutoSelect, disableAutoSelect = _d === void 0 ? true : _d, _e = deps.preventSubmit, preventSubmit = _e === void 0 ? false : _e, _f = deps.minLength, minLength = _f === void 0 ? 3 : _f;
                var autocompleteResult = autocomplete.autocomplete({
                    minLength: minLength,
                    input: inputEl,
                    disableAutoSelect: disableAutoSelect,
                    preventSubmit: preventSubmit,
                    onSelect: function (item, input) {
                        input.value = item.label || item.value;
                        onSelect && onSelect({ value: item.value, label: item.label });
                    },
                    fetch: function (text, update) {
                        text = text.toLowerCase();
                        autoCompleteSearch(text)
                            .then(function (res) { return update(res); });
                    },
                    render: function (item, currentValue) {
                        var itemEl = document.createElement("div");
                        eXpress.html.addClass(itemEl, 'm-autocomplete__item autocomplete-suggestion');
                        itemEl.innerHTML = renderTextContent && renderTextContent(item, currentValue) || "".concat(item.label, " - ").concat(item.value);
                        return itemEl;
                    },
                    customize: function (input, inputRect, container, maxHeight) {
                        customize && customize(input, inputRect, container, maxHeight);
                        eXpress.html.removeClass(container, 'autocomplete');
                        eXpress.html.addClass(container, containerClass);
                        container.removeAttribute('style');
                        container.style.display = "block";
                        var inputContainerEl = input.parentElement;
                        inputContainerEl.insertAdjacentElement(containerInsertPosition, container);
                        onOpen && onOpen();
                    },
                    debounceWaitMs: debounceWaitMs
                });
                var disposable = onClose
                    ? eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(inputEl, 'input', function (_) { if (inputEl.value && inputEl.value.length < minLength)
                            onClose(); }),
                        eXpress.html.addEventListener(inputEl, 'focusout', function (_) { onClose(); }),
                    ])
                    : null;
                return {
                    dispose: function () { disposable && disposable.dispose(); autocompleteResult.destroy(); },
                };
            }
            main.createTextInputWithAutoComplete = createTextInputWithAutoComplete;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initForm(formEl, deps) {
                var alternativeButton = deps.alternativeButton, onSubmitForm = deps.onSubmitForm, buttonSelector = deps.buttonSelector, submitOnEnter = deps.submitOnEnter, validatorOptions = deps.validatorOptions, onDirtyNavigateAway = deps.onDirtyNavigateAway;
                var onSubmit = function () {
                    return validate().then(function (x) {
                        if (!x)
                            return;
                        isDirty = false;
                        return onSubmitForm(formData());
                    });
                };
                var submitButtonEl = alternativeButton || eXpress.html.querySelector(formEl, buttonSelector || '.m-form__button-continue', true);
                var submitButton = main.createButton(submitButtonEl, onSubmit);
                var validator = createFormValidator(formEl, validatorOptions);
                createFormAddressSuggestor(formEl);
                var onKeyUpEvent;
                var isDirty = false;
                var formElements = [].slice.call(formEl.elements);
                var inputs = {};
                formElements
                    .filter(function (el) { return !el.matches("button"); })
                    .forEach(function (el) {
                    var input = null;
                    var email = el.attributes.getNamedItem("email");
                    if ((email && email.value === "email") || el.type === "email")
                        el.maxLength = 100;
                    if (el.classList.contains('a-form-input__select'))
                        input = main.createSelectBox(el.parentElement);
                    else if (el.classList.contains('a-form-input__input'))
                        input = el.type === "password" ? main.createPasswordFormInput(el.parentElement) : main.createFormInput(el.parentElement && el.parentElement.parentElement && el.parentElement.parentElement.classList.contains('a-form-input') ? el.parentElement.parentElement : el.parentElement);
                    else if (el.type === "hidden")
                        input = main.createHiddenFormInput(el);
                    if (input) {
                        var key = input.inputEl.id.toLowerCase();
                        if (!key)
                            key = input.inputEl.name;
                        inputs[key] = input;
                        input.inputEl.addEventListener('change', function () { isDirty = true; });
                    }
                });
                if (submitOnEnter && submitButtonEl && submitButtonEl.type.toLowerCase() !== "submit") {
                    onKeyUpEvent = eXpress.html.addEventListener(formEl, 'keyup', function (ev) { return ev.key === "Enter" && onSubmit(); });
                }
                if (onDirtyNavigateAway) {
                    var links = eXpress.html.querySelectorAll(document, "a");
                    links.forEach(function (link) {
                        return eXpress.html.addEventListener(link, 'click', function (event) {
                            if (!isDirty || eXpress.html.hasClass(formEl, "u-hide"))
                                return;
                            if (event.currentTarget instanceof HTMLAnchorElement) {
                                var url = event.currentTarget.href;
                                if (!url)
                                    return;
                                event.preventDefault();
                                onDirtyNavigateAway(url);
                            }
                            return;
                        });
                    });
                }
                var validate = function () {
                    resetValidation();
                    var promises = Object.keys(inputs)
                        .map(function (name) { return !inputs[name]["validatePassword"]
                        ? $.when(true)
                        : inputs[name].validatePassword(); });
                    var isFormValid = validator.validate();
                    var deferred = $.Deferred();
                    Promise.all(promises)
                        .then(function (x) {
                        var ok = x.every(function (v) { return v === true; });
                        deferred.resolve(ok && isFormValid);
                    })
                        .catch(function (x) {
                        deferred.resolve(false);
                    });
                    return deferred.promise();
                };
                var getInputs = function () { return Object.keys(inputs).map(function (key) { return inputs[key]; }); };
                var getInputByName = function (name) { return inputs[name.toLowerCase()]; };
                var dispose = function () {
                    clearAll(true);
                    submitButton.dispose();
                    onKeyUpEvent && onKeyUpEvent.dispose();
                };
                var toggleSubmitButton = function (enable) { return enable ? submitButton.enable() : submitButton.disable(); };
                var resetValidation = function () {
                    clearAll();
                    validator.reset();
                };
                var clearAll = function (clearValues) {
                    if (clearValues === void 0) { clearValues = false; }
                    getInputs()
                        .map(function (input) { return input.clear(clearValues); });
                };
                var setError = function (name, error, clear) {
                    if (clear === void 0) { clear = false; }
                    var input = getInputByName(name);
                    if (input)
                        input.setError(error, clear);
                };
                var setErrors = function (clear) {
                    if (clear === void 0) { clear = false; }
                    var errors = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        errors[_i - 1] = arguments[_i];
                    }
                    errors.forEach(function (e) { return setError(e.name, e.error, clear); });
                    if (errors.length) {
                        var input = getInputByName(errors[0].name);
                        if (input)
                            input.inputEl.parentElement.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                };
                var clearInput = function (name, clearValue) {
                    if (clearValue === void 0) { clearValue = false; }
                    var input = getInputByName(name);
                    if (input)
                        input.clear(clearValue);
                };
                var clearInputs = function (clearValue) {
                    if (clearValue === void 0) { clearValue = false; }
                    var names = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        names[_i - 1] = arguments[_i];
                    }
                    return names.forEach(function (name) { return clearInput(name, clearValue); });
                };
                var disableForm = function (disable) {
                    getInputs().map(function (i) { return disable ? i.disable() : i.enable(); });
                    resetValidation();
                    toggleSubmitButton(!disable);
                };
                var disableInput = function (name) {
                    var input = getInputByName(name);
                    if (input)
                        input.disable();
                };
                var setValue = function (name, value) {
                    var input = getInputByName(name);
                    if (input)
                        input.setValue(value);
                };
                var setValues = function () {
                    var values = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        values[_i] = arguments[_i];
                    }
                    return values.filter(function (v) { return getInputByName(v.name); })
                        .forEach(function (v) { return setValue(v.name, v.value); });
                };
                var formData = function () {
                    var data = {};
                    Object.keys(inputs).forEach(function (name) { return data[name] = inputs[name].getValue().toString() || ""; });
                    return data;
                };
                var hideInput = function (name) {
                    var input = getInputByName(name);
                    if (input)
                        input.hide();
                };
                var showInput = function (name) {
                    var input = getInputByName(name);
                    if (input)
                        input.show();
                };
                var setRequiredOnInput = function (name, value) {
                    var input = getInputByName(name);
                    if (input)
                        input.setRequired(value);
                };
                var disableButton = function () {
                    toggleSubmitButton(false);
                };
                var enableButton = function () {
                    toggleSubmitButton(true);
                };
                return {
                    dispose: dispose,
                    disableForm: disableForm,
                    disableInput: disableInput,
                    validate: validate,
                    setErrors: setErrors,
                    clearInputs: clearInputs,
                    clearAll: function () { return clearAll(true); },
                    setValues: setValues,
                    hideInput: hideInput,
                    showInput: showInput,
                    inputs: inputs,
                    disableButton: disableButton,
                    enableButton: enableButton,
                    setRequiredOnInput: setRequiredOnInput
                };
            }
            main.initForm = initForm;
            function createFormAddressSuggestor(form) {
                var autocompleteSuggestionClass = "technical-autocomplete-suggestion";
                var autocompleteSuggestionTemplateClass = "technical-autocomplete-suggestion-template";
                var elements = Array.from(form.elements);
                elements.forEach(function (el) {
                    var _a;
                    var attrValue = el.attributes.getNamedItem('addresssuggestions');
                    if (!attrValue)
                        return;
                    var currentEl = el;
                    var autoCompleteParent = eXpress.html.querySelector((_a = currentEl.parentElement) !== null && _a !== void 0 ? _a : currentEl, '.technical-autocomplete', false);
                    if (!autoCompleteParent)
                        return;
                    var type = attrValue.value;
                    var useExternalAddressValidationAttr = el.attributes.getNamedItem('useexternaladdressvalidation');
                    var useExternalAddressValidation = (useExternalAddressValidationAttr ? useExternalAddressValidationAttr.value : 'true') === "true";
                    if (!useExternalAddressValidation)
                        return;
                    var suggestionTemplate = eXpress.html.querySelector(autoCompleteParent, "." + autocompleteSuggestionTemplateClass, false);
                    if (!suggestionTemplate)
                        return;
                    var disposableEvents = eXpress.utils.compositeDisposable([]);
                    var inputChanged = function (ev) {
                        var streetEl = ev.target;
                        main.autocompleteAddressAsync(streetEl.value, form.elements.namedItem(type + 'HouseNumber').value, form.elements.namedItem(type + 'ZipCode').value, form.elements.namedItem(type + 'City').value, form.elements.namedItem(type + 'CountryId').value, main.AddressAutocompletionType.Street, 3).then(function (result) {
                            var suggestionsToRemove = eXpress.html.querySelectorAll(autoCompleteParent, "." + autocompleteSuggestionClass + ":not(." + autocompleteSuggestionTemplateClass + ")");
                            suggestionsToRemove.forEach(function (suggestionToRemove) {
                                autoCompleteParent.removeChild(suggestionToRemove);
                            });
                            disposableEvents.dispose();
                            if (!result || !Array.isArray(result) || result.length == 0) {
                                autoCompleteParent.style.display = "";
                                return;
                            }
                            autoCompleteParent.style.display = "block";
                            result.forEach(function (res) {
                                var newSuggestion = suggestionTemplate.cloneNode();
                                newSuggestion.innerHTML = eXpress.utils.capitalizeFirstLetterOfWords(res.street);
                                eXpress.html.removeClass(newSuggestion, autocompleteSuggestionTemplateClass);
                                eXpress.html.removeClass(newSuggestion, "u-hide");
                                var eventHandlers = [];
                                eventHandlers.push(eXpress.html.addEventListener(newSuggestion, "mousedown", function (ev) { return ev.preventDefault(); }));
                                eventHandlers.push(eXpress.html.addEventListener(newSuggestion, "click", function (ev) {
                                    var action = "";
                                    if (eXpress.html.hasClass(form, "technical-personal-data"))
                                        action = "ClickedStreetSuggestionPersonalData";
                                    if (eXpress.html.hasClass(form, "technical-delivery-address-form"))
                                        action = "ClickedStreetSuggestionDeliveryOptions";
                                    if (eXpress.html.hasClass(form, "technical-address-form"))
                                        action = "ClickedAddressSuggestionMyAccount";
                                    eXpress.analytics.trackAddressValidationEvent(action);
                                    currentEl.value = ev.currentTarget.innerHTML;
                                    autoCompleteParent.style.display = "";
                                }));
                                if (disposableEvents.add)
                                    disposableEvents.add(eventHandlers);
                                autoCompleteParent.appendChild(newSuggestion);
                            });
                        });
                    };
                    eXpress.html.addEventListener(el, 'keyup', eXpress.utils.debounce(inputChanged, 200));
                    eXpress.html.addEventListener(el, 'blur', function () { return autoCompleteParent.style.display = ''; });
                });
            }
            main.createFormAddressSuggestor = createFormAddressSuggestor;
            function createFormValidator(form, options) {
                if (options === void 0) { options = {}; }
                var _a = options.errorClass, errorClass = _a === void 0 ? 'a-form-input--error' : _a, _b = options.validClass, validClass = _b === void 0 ? 'a-form-input--validated' : _b, _c = options.onFocusIn, onFocusIn = _c === void 0 ? function (el, event) { return el.parentElement.classList.remove(errorClass); } : _c, _d = options.shouldScrollToFirstError, shouldScrollToFirstError = _d === void 0 ? true : _d, ignore = options.ignore, onValidate = options.onValidate;
                $.validator.addMethod("invalidchars", function (value, element) {
                    return this.optional(element) || eXpress.utils.isValidWithoutNonAlphaNumericCharsAtEnd(value, element);
                });
                $.validator.addMethod("notonlynumbers", function (value, element) {
                    return this.optional(element) || eXpress.utils.canNotContainOnlyNumerics(value);
                });
                $.validator.addMethod("regex", function (value, element, regexp) {
                    return this.optional(element) || new RegExp(regexp).test(value);
                });
                $.validator.addMethod("phonenumber", function (value, element, regexp) {
                    return this.optional(element) || new RegExp(regexp).test(value);
                });
                $.validator.addMethod("urlsafe", function (value, element) {
                    return this.optional(element) || eXpress.utils.isValidTextWithoutAngleBrackets(value);
                });
                $.validator.addMethod("blacklist", function (value, element, blacklist) {
                    if (!blacklist)
                        return true;
                    var list = blacklist.split(',');
                    for (var i = 0; i < list.length; i++)
                        if (value.toLowerCase() === list[i])
                            return false;
                    return true;
                });
                $.validator.addMethod("emailRFC822", function (value, element) {
                    return this.optional(element) || eXpress.utils.isValidEmailAddress(value);
                });
                $.validator.addMethod("vat", function (value, element, vat) {
                    return this.optional(element) || eXpress.utils.isValidVatNumber(value, vat);
                });
                $.validator.addMethod("personalnumber", function (value, element) {
                    return eXpress.utils.checkPersonalNumber(value, element.dataset.regioncode || "");
                });
                $.validator.addMethod("countrycode", function (value, element, countryCode) {
                    var _a, _b;
                    var regex = /\+[0-9{2-3}]+.*/g;
                    return this.optional(element) || value.length < 21 && ((_b = (_a = regex.exec(value)) === null || _a === void 0 ? void 0 : _a.every(function (x) { return x.length > 0; })) !== null && _b !== void 0 ? _b : false);
                });
                $.validator.addMethod("usehousenumber", function (value, element, useHouseNumber) {
                    if (!useHouseNumber)
                        return true;
                    var prefix = element.dataset.prefix || "";
                    var houseNumberEl = eXpress.html.querySelector(form, "input[name='" + prefix + "HouseNumber']", false);
                    if (!houseNumberEl || !houseNumberEl.value)
                        return true;
                    var atStart = value.trim().substring(0, houseNumberEl.value.trim().length + 1) === houseNumberEl.value.trim() + ' ';
                    var atEnd = value.trim().substring(value.trim().length - (houseNumberEl.value.trim().length + 1), value.trim().length) === ' ' + houseNumberEl.value.trim();
                    return this.optional(element) || !atStart && !atEnd;
                });
                $.validator.addMethod("passwordcheck", function (value, element) {
                    var passwordEl = eXpress.html.querySelector(form, "input[name='password']", false);
                    if (!passwordEl)
                        return true;
                    return value === passwordEl.value;
                });
                $.validator.addMethod("termsrequired", function (value, element) {
                    return value || (element && element instanceof HTMLInputElement && element.checked);
                });
                $.validator.addMethod("data-pristine-termsrequired", function (value, element) {
                    return value || (element && element instanceof HTMLInputElement && element.checked);
                }, jQuery.validator.messages['termsrequired']);
                var validator = $(form).validate({
                    errorClass: errorClass,
                    validClass: validClass,
                    errorElement: 'p',
                    errorPlacement: function ($error, $input) {
                        var errorMessage = $error[0].textContent || "";
                        var inputEl = $input[0];
                        var errorEl = eXpress.html.querySelector(inputEl.parentElement, '.a-form-input__error-text', false);
                        if (errorEl)
                            errorEl.innerHTML = errorMessage;
                    },
                    highlight: function (el, errorClass, validClass) {
                        el.parentElement.classList.add(errorClass);
                        el.parentElement.classList.remove(validClass);
                    },
                    unhighlight: function (el, errorClass, validClass) {
                        el.parentElement.classList.remove(errorClass);
                        el.parentElement.classList.add(validClass);
                    },
                    submitHandler: function () { return false; },
                    onkeyup: false,
                    onfocusout: false,
                    onfocusin: onFocusIn,
                    showErrors: function (map, list) {
                        if (this.defaultShowErrors)
                            this.defaultShowErrors();
                        if (shouldScrollToFirstError && list.length > 0) {
                            setTimeout(function () { return list[0].element.parentElement.scrollIntoView({ behavior: "smooth", block: "center" }); }, 250);
                        }
                    },
                    ignore: ignore
                });
                var validate = function () {
                    if (onValidate)
                        onValidate();
                    return validator.form();
                };
                return {
                    validate: validate,
                    reset: function () { return validator.resetForm(); }
                };
            }
            main.createFormValidator = createFormValidator;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createItemInCartUnavailable(deps) {
                var onClickDisposable;
                var init = function () {
                    deps.showItemInCartUnavailablePopup();
                };
                var detachClick = function () { return onClickDisposable && onClickDisposable.dispose(); };
                init();
                return {
                    dispose: function () {
                        detachClick();
                    }
                };
            }
            main.createItemInCartUnavailable = createItemInCartUnavailable;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createDropDownKeyboardNavigator(containerEl, deps) {
                var selectedClass = "selected";
                var getElementToFocus = function (el) {
                    if (el instanceof HTMLAnchorElement || el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
                        return el;
                    }
                    else {
                        return eXpress.html.querySelector(el, "a, button, input") || el;
                    }
                };
                var onArrowDown = function (e) {
                    e.preventDefault();
                    if (deps.onBeforeArrowDown) {
                        closeOtherDropDowns();
                        deps.onBeforeArrowDown();
                    }
                    if (!deps.dropdownItemEls || deps.dropdownItemEls.length === 0)
                        return;
                    var focusedEl = deps.dropdownItemEls.find(function (el) { return eXpress.html.hasClass(el, selectedClass); });
                    if (focusedEl) {
                        eXpress.html.removeClass(focusedEl, selectedClass);
                        var indexOfFocusedEl = Array.prototype.indexOf.call(deps.dropdownItemEls, focusedEl);
                        var nextEl = deps.dropdownItemEls[indexOfFocusedEl + 1];
                        if (nextEl) {
                            getElementToFocus(nextEl).focus();
                            eXpress.html.addClass(nextEl, selectedClass);
                        }
                        else {
                            getElementToFocus(deps.dropdownItemEls[0]).focus();
                            eXpress.html.addClass(deps.dropdownItemEls[0], selectedClass);
                        }
                    }
                    else {
                        getElementToFocus(deps.dropdownItemEls[0]).focus();
                        eXpress.html.addClass(deps.dropdownItemEls[0], selectedClass);
                    }
                };
                var onArrowUp = function (e) {
                    e.preventDefault();
                    if (deps.onBeforeArrowUp)
                        deps.onBeforeArrowUp();
                    if (!deps.dropdownItemEls || deps.dropdownItemEls.length === 0)
                        return;
                    var focusedEl = deps.dropdownItemEls.find(function (el) { return eXpress.html.hasClass(el, selectedClass); });
                    if (focusedEl) {
                        eXpress.html.removeClass(focusedEl, selectedClass);
                        var indexOfFocusedEl = Array.prototype.indexOf.call(deps.dropdownItemEls, focusedEl);
                        var prevEl = deps.dropdownItemEls[indexOfFocusedEl - 1];
                        if (prevEl) {
                            getElementToFocus(prevEl).focus();
                            eXpress.html.addClass(prevEl, selectedClass);
                        }
                        else {
                            getElementToFocus(deps.dropdownItemEls[deps.dropdownItemEls.length - 1]).focus();
                            eXpress.html.addClass(deps.dropdownItemEls[deps.dropdownItemEls.length - 1], selectedClass);
                        }
                    }
                    else {
                        getElementToFocus(deps.dropdownItemEls[deps.dropdownItemEls.length - 1]).focus();
                        eXpress.html.addClass(deps.dropdownItemEls[deps.dropdownItemEls.length - 1], selectedClass);
                    }
                };
                var onEnter = function (e) {
                    if (!deps.dropdownItemEls)
                        return;
                    closeOtherDropDowns();
                    var focusedEl = deps.dropdownItemEls.find(function (el) { return eXpress.html.hasClass(el, selectedClass); });
                    if (focusedEl)
                        eXpress.html.removeClass(focusedEl, selectedClass);
                    deps.onEnter(e);
                };
                var onEscape = function (e) {
                    if (!deps.dropdownItemEls)
                        return;
                    var focusedEl = deps.dropdownItemEls.find(function (el) { return eXpress.html.hasClass(el, selectedClass); });
                    if (focusedEl)
                        eXpress.html.removeClass(focusedEl, selectedClass);
                    deps.onEscape(e);
                };
                var onKeyDown = function (e) {
                    if (e.key === "Enter")
                        onEnter(e);
                    if (e.key === "Escape")
                        onEscape(e);
                    if (e.key === "ArrowUp" && (deps.dropdownItemEls || deps.onArrowUp))
                        deps.dropdownItemEls ? onArrowUp(e) : deps.onArrowUp && deps.onArrowUp(e);
                    if (e.key === "ArrowDown" && (deps.dropdownItemEls || deps.onArrowDown))
                        deps.dropdownItemEls ? onArrowDown(e) : deps.onArrowDown && deps.onArrowDown(e);
                };
                var closeOtherDropDowns = function () {
                    var openDropdowns = eXpress.html.querySelectorAll(document, ".menu-is-open, .a-language-selector--open");
                    openDropdowns.forEach(function (dropdown) {
                        eXpress.html.removeClass(dropdown, "menu-is-open");
                        eXpress.html.removeClass(dropdown, "a-language-selector--open");
                    });
                };
                return eXpress.html.addEventListener(containerEl, "keydown", onKeyDown);
            }
            main.createDropDownKeyboardNavigator = createDropDownKeyboardNavigator;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initLanguageSelector(buttonEl) {
                var eventDisposables;
                var onDocumentClickDisposable;
                var openClassName = "a-language-selector--open";
                var openMenu = function () {
                    buttonEl.classList.add(openClassName);
                    attachOnDocumentClick();
                };
                var isClosed = function () { return !buttonEl.classList.contains(openClassName); };
                var closeMenu = function () {
                    buttonEl.classList.remove(openClassName);
                    detachDocumentClick();
                };
                var onDocumentClick = function (e) {
                    if (!e.target.closest(".technical-language-selector, .technical-language-selector-choices")) {
                        closeMenu();
                    }
                };
                var onButtonClick = function () {
                    if (!buttonEl.classList.contains(openClassName))
                        attachOnDocumentClick();
                    buttonEl.classList.toggle(openClassName);
                };
                var attachOnDocumentClick = function () {
                    return (onDocumentClickDisposable = eXpress.utils.compositeDisposable([eXpress.html.addEventListener(document, 'click', onDocumentClick, true)]));
                };
                var detachDocumentClick = function () { return onDocumentClickDisposable && onDocumentClickDisposable.dispose(); };
                var init = function () {
                    eventDisposables = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(buttonEl, 'click', onButtonClick)
                    ]);
                    if (!eXpress.html.isMobile()) {
                        eventDisposables.add([main.createDropDownKeyboardNavigator(buttonEl, {
                                onEscape: closeMenu,
                                onEnter: openMenu,
                                onBeforeArrowDown: function () {
                                    if (isClosed())
                                        openMenu();
                                },
                                dropdownItemEls: eXpress.html.querySelectorAll(buttonEl, ".a-language-selector__link"),
                            })]);
                    }
                };
                var deInit = function () {
                    dispose();
                    closeMenu();
                };
                var dispose = function () {
                    if (eventDisposables)
                        eventDisposables.dispose();
                    detachDocumentClick();
                };
                init();
                return {
                    deInit: deInit,
                    dispose: dispose,
                };
            }
            main.initLanguageSelector = initLanguageSelector;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            var MainNavigation = (function () {
                function MainNavigation(containerEl, deps) {
                    var _this = this;
                    this.toggleScroll = function () {
                        return !_this.getScrollingElement().classList.contains('u-no-scroll-mobile')
                            ? _this.getScrollingElement().classList.add('u-no-scroll-mobile')
                            : _this.getScrollingElement().classList.remove('u-no-scroll-mobile');
                    };
                    this.getScrollingElement = function () { return (document.scrollingElement || document.documentElement); };
                    this.mainNavigationEl = containerEl;
                    this.mobileMenuEl = eXpress.html.querySelector(this.mainNavigationEl, "#technical-mobile-menu", false);
                    this.mainNavigationDependencies = deps;
                    this.isMobile = function () { return eXpress.html.isMobileOnPageWithHeader(); };
                    this.initComponents();
                }
                MainNavigation.prototype.initEventAnimation = function () {
                    var _this = this;
                    var eventContainer = eXpress.html.querySelector(this.mainNavigationEl, '.technical-event-container', false);
                    if (!eventContainer || !window['lottie'])
                        return {
                            toggleEventVisibility: function () { return; }
                        };
                    var imageContainer = eXpress.html.querySelector(this.mainNavigationEl, '.technical-animate-img', true);
                    var seen = eXpress.utils.getCookie('evSeen') && eXpress.utils.getCookie('evSeen') === '1';
                    var stickyNav = eventContainer.dataset.stickynav === 'true';
                    var mobile = this.isMobile();
                    var animation = lottie.loadAnimation({
                        container: imageContainer,
                        renderer: 'svg',
                        loop: false,
                        autoplay: false,
                        path: window.context.cdn + imageContainer.dataset.catimage,
                        initialSegment: seen ? [255, 354] : [0, 354]
                    });
                    animation.addEventListener('complete', function () {
                        animation.playSegments([255, 354], true);
                    });
                    var animate = eXpress.html.querySelector(eventContainer, ".technical-animate-img", true);
                    animate.style.transition = "opacity 0.5s";
                    animate.style.opacity = "1";
                    var eventContainerInitialHeight = eventContainer.clientHeight;
                    var toggleEventVisibility = function (visiblePx) {
                        if (!mobile) {
                            imageContainer.style.opacity = "".concat(1 - ((100 / 70) * visiblePx) / 100);
                            return;
                        }
                        eventContainer.style.opacity = "".concat(1 - ((100 / 70) * visiblePx) / 100);
                        eventContainer.style.height = "".concat(eventContainerInitialHeight - ((100 / 70) * visiblePx) / 5, "px");
                        if (stickyNav) {
                            var mobileSearchBar = eXpress.html.querySelector(_this.mainNavigationEl, '.technical-mobile-searchbar', true);
                            mobileSearchBar.style.top = "".concat(130 - visiblePx, "px");
                        }
                    };
                    if (stickyNav)
                        document.addEventListener('scroll', function (_) { return !_this.getScrollingElement().classList.contains('u-no-scroll-mobile') && toggleEventVisibility(mobile ? window.scrollY > eventContainerInitialHeight ? eventContainerInitialHeight : window.scrollY : 0); });
                    animation.play();
                    if (!seen)
                        eXpress.utils.writeCookieThatExpiresAtTheEndOfTheDay('evSeen', '1');
                    return {
                        toggleEventVisibility: function (hide) { return toggleEventVisibility(hide ? eventContainerInitialHeight : 0); }
                    };
                };
                MainNavigation.prototype.initComponents = function () {
                    var _this = this;
                    var eventAnimation = this.initEventAnimation();
                    var onOpen = function () { eventAnimation.toggleEventVisibility(true); };
                    var onClose = function () { eventAnimation.toggleEventVisibility(false); };
                    this.initMobileMenu(onOpen, onClose);
                    var loadDesktopMenuItemAsync = function (firstLevel, secondLevel) {
                        if (firstLevel === void 0) { firstLevel = -1; }
                        if (secondLevel === void 0) { secondLevel = -1; }
                        if (secondLevel < 0)
                            return $.ajax({ url: "/apicore/header/desktopmenu?indexLevel1=" + firstLevel, traditional: true }).then(function (res) { return res; });
                        else
                            return $.ajax({ url: "/apicore/header/desktopmenu?indexLevel1=" + firstLevel + "&indexLevel2=" + secondLevel, traditional: true }).then(function (res) { return res; });
                    };
                    var desktopLeftMenuEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-desktop-left-menu', false);
                    if (desktopLeftMenuEl) {
                        main.initNavigationDesktop(desktopLeftMenuEl, { loadDesktopMenuItemAsync: loadDesktopMenuItemAsync });
                    }
                    var langButtonEl = eXpress.html.querySelector(this.mainNavigationEl, ".technical-language-selector", false);
                    langButtonEl && main.initLanguageSelector(langButtonEl);
                    var searchBarEl = eXpress.html.querySelector(this.mainNavigationEl, ".o-main-navigation__searchbar", false);
                    if (searchBarEl) {
                        main.initSearchBar(searchBarEl, eXpress.html.querySelector(this.mainNavigationEl, ".o-icon-navigation__search-bar", true), function (searchTerm) { return $.ajax({ url: "/apicore/searchapi/autocomplete", type: "GET", data: { searchTerm: searchTerm } }).then(function (res) { return res; }); }, function () { !_this.isMobile() && eventAnimation.toggleEventVisibility(true); }, function () { !_this.isMobile() && eventAnimation.toggleEventVisibility(false); });
                    }
                    var notificationCenterEl = eXpress.html.querySelector(this.mainNavigationEl, '.o-icon-navigation__notifications-center', false);
                    if (notificationCenterEl) {
                        components.main.createNotificationCenter(notificationCenterEl, {
                            getNotifications: function () { return $.ajax({ url: "/apicore/header/loadnotificationtiles", cache: false })
                                .then(function (res) { return res; }); },
                            isMobile: this.isMobile,
                            markNotificationsAsRead: function (notificationIds) { return $.ajax({
                                url: "/apicore/header/marknotificationasread",
                                type: "POST",
                                data: { notificationIds: notificationIds },
                                traditional: true,
                            }).then(function (res) { return res; }); },
                            onOpen: function () { _this.isMobile() && eventAnimation.toggleEventVisibility(true); _this.toggleScroll(); },
                            onClose: function () { eventAnimation.toggleEventVisibility(false); _this.toggleScroll(); },
                        });
                    }
                    var myAccountMenuEl = eXpress.html.querySelector(this.mainNavigationEl, '.o-icon-navigation__user-menu', false);
                    if (myAccountMenuEl) {
                        main.initMyAccount(this.mainNavigationEl, {
                            getIconsAsync: this.mainNavigationDependencies.getIconsAsync,
                            isMobile: this.isMobile,
                            onOpen: function () { _this.isMobile() && eventAnimation.toggleEventVisibility(true); _this.toggleScroll(); },
                            onClose: function () { eventAnimation.toggleEventVisibility(false); _this.toggleScroll(); },
                            loadAccountMenu: function () { return $.ajax({ url: "/apicore/header/loadmyaccount" }).then(function (res) { return res; }); },
                        });
                    }
                    var leadTimesBarEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-leadtimes', false);
                    if (leadTimesBarEl) {
                        main.createClickableElement(leadTimesBarEl, this.mainNavigationDependencies.openLeadTimesPopupAsync);
                        eXpress.utils.getParameter('leadtimes') === 'true' && leadTimesBarEl.click();
                    }
                    var topBarContainerEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-top-bar-container', false);
                    if (topBarContainerEl) {
                        var countDownEls = eXpress.html.querySelectorAll(topBarContainerEl, ".technical-countdown");
                        countDownEls.forEach(function (el) {
                            var countDownToDate = el.dataset.countdown || "";
                            var daysLabel = el.dataset.dayslabel || "";
                            var dayLabel = el.dataset.daylabel || "";
                            if (countDownToDate !== "") {
                                var onCountDownFinish = function () {
                                    var barEls = eXpress.html.querySelectorAll(topBarContainerEl, ".technical-top-bar");
                                    if (barEls.length === 1) {
                                        eXpress.html.hide(topBarContainerEl);
                                    }
                                    else {
                                        var myTopBar_1 = eXpress.html.getParentWithClassName(el, "technical-top-bar");
                                        myTopBar_1 && myTopBar_1.remove();
                                        topBarContainerEl.classList.remove("m-top-bar--combo");
                                        topBarContainerEl.classList.add("m-top-bar--single");
                                        var otherTopBar = barEls.filter(function (el) { return el !== myTopBar_1; })[0];
                                        if (otherTopBar)
                                            otherTopBar.outerHTML = otherTopBar.innerHTML;
                                    }
                                };
                                main.initCountDown(topBarContainerEl, el, countDownToDate, { showDays: true, onCountDownFinish: onCountDownFinish, daysLabel: daysLabel, dayLabel: dayLabel });
                            }
                        });
                    }
                };
                MainNavigation.prototype.initMobileMenu = function (onOpen, onClose) {
                    var _this = this;
                    if (this.mobileMenuEl) {
                        var oldMobileMenuContainerEl = eXpress.html.querySelector(document, ".technical-mobile-navigation-hamburger-menu-container", false);
                        var menuButtonEl = eXpress.html.querySelector(document, ".technical-mobile-navigation-hamburger-menu-button", true);
                        if (oldMobileMenuContainerEl) {
                            main.initNavigationMobile({
                                mobileMenuEl: this.mobileMenuEl,
                                containerEl: eXpress.html.querySelector(document, ".technical-mobile-navigation", true),
                                menuButtonEl: menuButtonEl,
                                menuContainerEl: oldMobileMenuContainerEl,
                            }, {
                                getMobileMenu: function (indexLevel2, indexLevel3) { return $.ajax({
                                    url: "/apicore/header/mobilemenu",
                                    data: {
                                        indexLevel2: indexLevel2 !== null && indexLevel2 !== void 0 ? indexLevel2 : -1,
                                        indexLevel3: indexLevel3 !== null && indexLevel3 !== void 0 ? indexLevel3 : -1,
                                        pageId: _this.mobileMenuEl && _this.mobileMenuEl.getAttribute("data-page-id")
                                    }, cache: false
                                })
                                    .then(function (res) { return res; }); },
                                getIconsAsync: this.mainNavigationDependencies.getIconsAsync,
                                onClose: function () {
                                    onClose();
                                    _this.toggleScroll();
                                },
                                onOpen: function () {
                                    onOpen();
                                    _this.toggleScroll();
                                },
                            });
                        }
                        else {
                            main.initNavigationMobileNew(this.mobileMenuEl, menuButtonEl, {
                                getMobileMenu: function (indexLevel2, indexLevel3) { return $.ajax({
                                    url: "/apicore/headerapi/mobilemenu",
                                    data: {
                                        indexLevel2: indexLevel2 !== null && indexLevel2 !== void 0 ? indexLevel2 : -1,
                                        indexLevel3: indexLevel3 !== null && indexLevel3 !== void 0 ? indexLevel3 : -1,
                                        pageId: _this.mobileMenuEl && _this.mobileMenuEl.getAttribute("data-page-id")
                                    }, cache: false
                                })
                                    .then(function (res) { return res; }); },
                                getIconsAsync: this.mainNavigationDependencies.getIconsAsync,
                                onClose: function () {
                                    onClose();
                                    _this.toggleScroll();
                                },
                                onOpen: function () {
                                    onOpen();
                                    _this.toggleScroll();
                                }
                            });
                        }
                    }
                };
                return MainNavigation;
            }());
            main.MainNavigation = MainNavigation;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initMyAccount(mainNavigationEl, deps) {
                var getIconsAsync = deps.getIconsAsync, onClose = deps.onClose, onOpen = deps.onOpen, isMobile = deps.isMobile, loadAccountMenu = deps.loadAccountMenu;
                var onDocumentClickDisposable;
                var keyboardNavigatorDisposables;
                var icons = {};
                var loaded = false;
                var myAccountContainerEl = eXpress.html.querySelector(mainNavigationEl, ".o-icon-navigation__user", true);
                var buttonEl = eXpress.html.querySelector(myAccountContainerEl, '.o-icon-navigation__user-icon', true);
                var menuEl = eXpress.html.querySelector(myAccountContainerEl, '.o-icon-navigation__user-menu', true);
                var overLayEl = eXpress.html.querySelector(menuEl, '.technical-navigation-overlay', true);
                var contentEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__content', true);
                var closeButtonEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__close-container', true);
                var setOverLayClass = function () {
                    var _a;
                    (_a = overLayEl.classList).remove.apply(_a, ["m-navigation-overlay__mobile-view", "m-navigation-overlay__desktop-view"]);
                    overLayEl.classList.add(isMobile() ? "m-navigation-overlay__mobile-view" : "m-navigation-overlay__desktop-view");
                };
                var onOpenMyAccount = function () {
                    if (!loaded) {
                        return loadAccountMenu()
                            .then(function (res) {
                            onOpen && onOpen();
                            contentEl.insertAdjacentHTML('beforeend', res);
                            var buttonEls = eXpress.html.querySelectorAll(contentEl, '.technical-hassvg');
                            var urls = buttonEls
                                .filter(function (el) { return !!el.getAttribute('data-icon-svg'); })
                                .map(function (el) { return el.getAttribute('data-icon-svg'); })
                                .filter(function (value, index, self) { return self.indexOf(value) === index; });
                            getIconsAsync(urls)
                                .then(function (res) {
                                res.forEach(function (icon) { return icons[icon.url] = icon.svg; });
                                buttonEls.forEach(function (el) { return el.insertAdjacentHTML('beforeend', icons[el.getAttribute('data-icon-svg')]); });
                            });
                            if (!isMobile()) {
                                keyboardNavigatorDisposables.dispose();
                                keyboardNavigatorDisposables.add([main.createDropDownKeyboardNavigator(myAccountContainerEl, {
                                        onEnter: onButtonClick,
                                        onEscape: onCloseIconClick,
                                        onBeforeArrowDown: function () {
                                            if (!menuEl.classList.contains("menu-is-open"))
                                                openMenu();
                                        },
                                        dropdownItemEls: eXpress.html.querySelectorAll(contentEl, ".m-navigation-mobile-ui"),
                                    })]);
                            }
                            loaded = true;
                        });
                    }
                    else {
                        onOpen && onOpen();
                        return $.Deferred().resolve().promise();
                    }
                };
                var closeMenu = function () {
                    onClose && onClose();
                    menuEl.classList.remove("menu-is-open");
                    detachDocumentClick();
                    return $.Deferred().resolve().promise();
                };
                var openMenu = function () {
                    setOverLayClass();
                    return onOpenMyAccount()
                        .then(function () {
                        menuEl.classList.add("menu-is-open");
                        if (isMobile()) {
                            var menuButtonList = eXpress.html.querySelector(menuEl, '.o-my-account__list', true);
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuButtonList);
                        }
                        attachOnDocumentClick();
                    });
                };
                var onCloseIconClick = function (e) {
                    e.stopPropagation();
                    closeMenu();
                };
                var onButtonClick = function () {
                    return menuEl.classList.contains("menu-is-open")
                        ? closeMenu()
                        : openMenu();
                };
                var onDocumentClick = function (e) {
                    if (!e.target.closest(".o-icon-navigation__user-menu, .o-icon-navigation__user-icon")) {
                        closeMenu();
                    }
                };
                var button = main.createClickableElement(buttonEl, onButtonClick);
                var eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(closeButtonEl, 'click', onCloseIconClick),
                    eXpress.html.addEventListener(window, 'resize', setOverLayClass)
                ]);
                var attachOnDocumentClick = function () {
                    return (onDocumentClickDisposable = eXpress.html.addEventListener(document, 'click', onDocumentClick, true));
                };
                var detachDocumentClick = function () { return onDocumentClickDisposable && onDocumentClickDisposable.dispose(); };
                if (!isMobile()) {
                    keyboardNavigatorDisposables = eXpress.utils.compositeDisposable([
                        main.createDropDownKeyboardNavigator(myAccountContainerEl, {
                            onEnter: onButtonClick,
                            onEscape: onCloseIconClick,
                            onBeforeArrowDown: function () {
                                if (!menuEl.classList.contains("menu-is-open"))
                                    openMenu();
                            },
                            dropdownItemEls: [],
                        }),
                    ]);
                }
                return {
                    dispose: function () {
                        eventDisposables.dispose();
                        detachDocumentClick();
                        button.dispose();
                        closeMenu();
                    }
                };
            }
            main.initMyAccount = initMyAccount;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initNavigationDesktop(containerEl, deps) {
                var firstLevelMenuEls = eXpress.html.querySelectorAll(containerEl, ".technical-desktop-first-level-menu-item");
                var loadDesktopMenuItemAsync = deps.loadDesktopMenuItemAsync;
                var loadedMenuItemsKeys = [];
                var disposable;
                var firstLevelActiveClass = "o-menu-first-level__button--active";
                var secondLevelActiveClass = "o-menu-second-level__list-item--active";
                var closeMenu = function (e) {
                    e.stopPropagation();
                    var clickedItem = e.currentTarget;
                    if (eXpress.html.getParentWithClassName(clickedItem, 'o-menu-second-level__list'))
                        return;
                    firstLevelMenuEls.forEach(function (el) { return closeFirstLevelMenuItemAndResetChildMenus(el); });
                };
                var closeFirstLevelMenuItemAndResetChildMenus = function (menuItem) {
                    var buttonEL = eXpress.html.querySelector(menuItem, '.technical-level1-button', true);
                    eXpress.html.removeClass(buttonEL, firstLevelActiveClass);
                    closeAllSecondLevelMenuItemsAndResetChildMenus(menuItem);
                };
                var closeAllSecondLevelMenuItemsAndResetChildMenus = function (menuItem) {
                    var secondLevelMenuEls = eXpress.html.querySelectorAll(menuItem, '.technical-desktop-menu-second');
                    secondLevelMenuEls.forEach(function (secondLevelMenuEl) {
                        eXpress.html.addClass(secondLevelMenuEl, 'u-hide');
                        closeAllThirdLevelMenuItemsAndResetChildMenus(secondLevelMenuEl);
                    });
                };
                var closeAllThirdLevelMenuItemsAndResetChildMenus = function (menuItem) {
                    var allThirdLevelMenuItems = eXpress.html.querySelectorAll(menuItem, '.technical-desktop-second-level-menu-item');
                    allThirdLevelMenuItems.forEach(function (el) {
                        var contentEl = eXpress.html.querySelector(el, '.technical-desktop-second-level-content', false);
                        contentEl && eXpress.html.addClass(contentEl, 'u-hide');
                        eXpress.html.removeClass(el, secondLevelActiveClass);
                    });
                };
                var getOrLoadFirstLevelMenuItem = function (e) {
                    e.stopPropagation();
                    if (e.type.toLowerCase() === "mouseenter" && eXpress.utils.isTouchDevice())
                        return;
                    var menuItem = e.currentTarget;
                    var secondLevelMenuEl = eXpress.html.querySelector(menuItem, '.technical-desktop-menu-second', true);
                    var buttonEL = eXpress.html.querySelector(menuItem, '.technical-level1-button', true);
                    var closeMenuOnMouseOut = function (e) {
                        var menuItem = e.currentTarget;
                        closeFirstLevelMenuItemAndResetChildMenus(menuItem);
                    };
                    var allSecondLevelMenuItems = eXpress.html.querySelectorAll(containerEl, '.technical-desktop-menu-second');
                    allSecondLevelMenuItems.forEach(function (el) { return closeAllSecondLevelMenuItemsAndResetChildMenus(el); });
                    if (eXpress.html.querySelectorAll(secondLevelMenuEl, ".o-menu-second-level__list.skeleton-loading").length === 1) {
                        var itemKey = parseInt(menuItem.getAttribute("data-menu-item") || "", 10);
                        var alreadyLoaded = itemKey in loadedMenuItemsKeys;
                        if (!alreadyLoaded) {
                            loadedMenuItemsKeys[itemKey] = [];
                            eXpress.html.addClass(buttonEL, firstLevelActiveClass);
                            loadDesktopMenuItemAsync(itemKey, -1).then(function (res) {
                                secondLevelMenuEl.innerHTML = "";
                                secondLevelMenuEl.insertAdjacentHTML('beforeend', res);
                                window.addEventListener('resize', function () {
                                    eXpress.utils.debounce(function () {
                                        if (!secondLevelMenuEl)
                                            return;
                                        secondLevelMenuEl.style.top = Math.floor(parseFloat(window.getComputedStyle(eXpress.html.querySelector(document, '.technical-header', true)).height)) + 'px';
                                    }, 250);
                                });
                                secondLevelMenuEl.style.top = Math.floor(parseFloat(window.getComputedStyle(eXpress.html.querySelector(document, '.technical-header', true)).height)) + 'px';
                                var buttonEls = eXpress.html.querySelectorAll(secondLevelMenuEl, '.technical-third-link-item');
                                if (buttonEls.every(function (x) { return x.nodeName.toLowerCase() === 'a'; })) {
                                    var subMenuListEl = eXpress.html.querySelector(secondLevelMenuEl, '.o-menu-second-level__list', true);
                                    subMenuListEl.style.left = (menuItem.offsetLeft - containerEl.offsetLeft) + "px";
                                }
                                initSecondLevelListeners();
                                if (eXpress.html.hasClass(buttonEL, firstLevelActiveClass))
                                    eXpress.html.removeClass(secondLevelMenuEl, 'u-hide');
                            });
                            if (disposable && disposable.add) {
                                disposable.add([eXpress.utils.compositeDisposable(firstLevelMenuEls.map(function (el) { return eXpress.html.addEventListener(el, 'mouseleave', closeMenuOnMouseOut); }))]);
                                disposable.add([eXpress.html.addEventListener(secondLevelMenuEl, 'click', closeMenu)]);
                            }
                        }
                    }
                    else {
                        if (e.type.toLowerCase() === "click" && eXpress.utils.isTouchDevice()) {
                            if (eXpress.html.hasClass(buttonEL, firstLevelActiveClass)) {
                                eXpress.html.removeClass(buttonEL, firstLevelActiveClass);
                                eXpress.html.addClass(secondLevelMenuEl, 'u-hide');
                                closeAllThirdLevelMenuItemsAndResetChildMenus(secondLevelMenuEl);
                            }
                            else {
                                eXpress.html.addClass(buttonEL, firstLevelActiveClass);
                                eXpress.html.removeClass(secondLevelMenuEl, 'u-hide');
                            }
                        }
                        else {
                            eXpress.html.addClass(buttonEL, firstLevelActiveClass);
                            eXpress.html.removeClass(secondLevelMenuEl, 'u-hide');
                        }
                    }
                };
                var initFirstLevelListeners = function () {
                    disposable = eXpress.utils.compositeDisposable(firstLevelMenuEls.map(function (el) { return eXpress.html.addEventListener(el, 'mouseenter', getOrLoadFirstLevelMenuItem); }));
                    disposable && disposable.add && disposable.add([eXpress.utils.compositeDisposable(firstLevelMenuEls.map(function (el) { return eXpress.html.addEventListener(el, 'click', getOrLoadFirstLevelMenuItem); }))]);
                };
                var getOrLoadSecondLevelMenuItem = function (e) {
                    e.stopPropagation();
                    if (e.type.toLowerCase() === "mouseenter" && eXpress.utils.isTouchDevice())
                        return;
                    var menuItem = e.currentTarget;
                    if (eXpress.html.hasClass(menuItem, secondLevelActiveClass))
                        return;
                    var parent = menuItem.closest(".technical-desktop-first-level-menu-item");
                    closeAllThirdLevelMenuItemsAndResetChildMenus(parent);
                    eXpress.html.addClass(menuItem, secondLevelActiveClass);
                    var contentEl = eXpress.html.querySelector(menuItem, '.technical-desktop-second-level-content', false);
                    contentEl && eXpress.html.removeClass(contentEl, 'u-hide');
                    var buttonEl = eXpress.html.querySelector(menuItem, '.technical-third-link-item', true);
                    if (buttonEl.nodeName.toLowerCase() === "button") {
                        var firstLevelIndex = parseInt(parent.getAttribute("data-menu-item") || "", 10);
                        var secondLevelIndex = parseInt(menuItem.getAttribute("data-menu-item") || "", 10);
                        var alreadyLoaded = loadedMenuItemsKeys[firstLevelIndex].includes(secondLevelIndex);
                        if (!alreadyLoaded) {
                            loadedMenuItemsKeys[firstLevelIndex].push(secondLevelIndex);
                            loadDesktopMenuItemAsync(firstLevelIndex, secondLevelIndex).then(function (res) {
                                var contentItem = menuItem.querySelector(".technical-desktop-second-level-content");
                                if (contentItem)
                                    contentItem.innerHTML = res;
                            });
                        }
                    }
                };
                var initSecondLevelListeners = function () {
                    var secondLevelMenuEls = eXpress.html.querySelectorAll(containerEl, ".technical-desktop-second-level-menu-item");
                    if (disposable && disposable.add) {
                        disposable.add([eXpress.utils.compositeDisposable(secondLevelMenuEls.map(function (el) { return eXpress.html.addEventListener(el, 'mouseenter', getOrLoadSecondLevelMenuItem); }))]);
                        disposable.add([eXpress.utils.compositeDisposable(secondLevelMenuEls.map(function (el) { return eXpress.html.addEventListener(el, 'click', getOrLoadSecondLevelMenuItem); }))]);
                    }
                };
                initFirstLevelListeners();
                var disableHoverMenuItems = function () { return disposable && disposable.dispose(); };
                return { dispose: disableHoverMenuItems };
            }
            main.initNavigationDesktop = initNavigationDesktop;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initHamburgerMenu(buttonEl, deps) {
                var openClass = "a-hamburger-menu--open";
                var onButtonClick = deps.onButtonClick;
                var menuButtonComponent = main.createClickableElement(buttonEl, onButtonClick);
                return {
                    open: function () { return buttonEl.classList.add(openClass); },
                    close: function () { return buttonEl.classList.remove(openClass); },
                    toggle: function (force) { return buttonEl.classList.toggle(openClass, force); },
                    dispose: function () { return menuButtonComponent.dispose(); },
                };
            }
            main.initHamburgerMenu = initHamburgerMenu;
            function initNavigationMobile(options, deps) {
                var firstLevelMenuSelected;
                var onDocumentClickDisposable;
                var onCloseClickDisposable;
                var userContainerEl;
                var closeContainerEl;
                var languageSelectorEl;
                var firstLevelMenuEls;
                var secondLevelMenuEls;
                var thirdLevelMenuEls;
                var loaded = false;
                var mobileMenuEl = options.mobileMenuEl, containerEl = options.containerEl, menuButtonEl = options.menuButtonEl, menuContainerEl = options.menuContainerEl;
                var getMobileMenu = deps.getMobileMenu, getIconsAsync = deps.getIconsAsync, onOpen = deps.onOpen, onClose = deps.onClose;
                var contentPreLoaded = mobileMenuEl.innerHTML.replace(/^\s+|\s+$/, '') !== "";
                var onButtonClick = function () {
                    return menuContainerEl.classList.contains("menu-is-open")
                        ? closeMenu()
                        : openMenu();
                };
                var hamburgerMenuComponent = initHamburgerMenu(menuButtonEl, {
                    onButtonClick: onButtonClick,
                });
                var closeMenu = function () {
                    hamburgerMenuComponent.close();
                    menuContainerEl.classList.remove("menu-is-open");
                    resetMenu();
                    detachDocumentClick();
                    if (onClose)
                        onClose();
                    return $.Deferred().resolve().promise();
                };
                var onCloseMenuClick = function (e) {
                    e.stopPropagation();
                    closeMenu();
                };
                var onDocumentClick = function (e) {
                    if (!e.target.closest(".technical-mobile-navigation-hamburger-menu-container, .technical-mobile-navigation-hamburger-menu-button")) {
                        closeMenu();
                    }
                };
                var attachOnDocumentClick = function () {
                    return (onDocumentClickDisposable = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(document, 'click', onDocumentClick, true)
                    ]));
                };
                var detachDocumentClick = function () { return onDocumentClickDisposable && onDocumentClickDisposable.dispose(); };
                var loadIcons = function (urls) {
                    var icons = {};
                    var uniqueUrls = urls.filter(function (v, i) { return urls.indexOf(v) === i; });
                    return getIconsAsync(uniqueUrls)
                        .then(function (res) {
                        res.forEach(function (icon) { return (icons[icon.url] = icon.svg); });
                        return icons;
                    });
                };
                var initMenuItemsAndBehavior = function () {
                    var firstLevelListEl = eXpress.html.querySelector(mobileMenuEl, ".o-navigation-mobile__first-level-navigation__button-list", true);
                    userContainerEl = eXpress.html.querySelector(mobileMenuEl, ".technical-mobile-navigation-user-container", true);
                    closeContainerEl = eXpress.html.querySelector(mobileMenuEl, ".technical-mobile-navigation-close-container", true);
                    languageSelectorEl = eXpress.html.querySelector(mobileMenuEl, ".technical-language-selector") || undefined;
                    firstLevelMenuEls = eXpress.html.querySelectorAll(mobileMenuEl, ".technical-mobile-navigation-first-level-container");
                    secondLevelMenuEls = eXpress.html.querySelectorAll(mobileMenuEl, ".technical-mobile-navigation-second-level-container");
                    thirdLevelMenuEls = eXpress.html.querySelectorAll(mobileMenuEl, ".o-navigation-mobile__third-level-navigation__button-container");
                    languageSelectorEl && main.initLanguageSelector(languageSelectorEl);
                    var iconButtonEls = eXpress.html.querySelectorAll(firstLevelListEl, '.technical-icon-svg')
                        .filter(function (el) { return !!el.getAttribute('data-icon-svg'); });
                    if (iconButtonEls.length > 0) {
                        loadIcons(iconButtonEls.map(function (el) { return el.getAttribute('data-icon-svg'); }))
                            .then(function (res) {
                            return iconButtonEls.forEach(function (el) {
                                var icon = res[el.getAttribute('data-icon-svg')];
                                if (icon)
                                    el.insertAdjacentHTML("beforeend", icon);
                            });
                        });
                    }
                    if (closeContainerEl)
                        attachCloseMenuClick(closeContainerEl);
                    attachFirstMenuItemClick(firstLevelMenuEls);
                };
                var loadMobileMenu = function () {
                    if (!loaded) {
                        if (!contentPreLoaded) {
                            return getMobileMenu()
                                .then(function (res) {
                                onOpen && onOpen();
                                loaded = true;
                                mobileMenuEl.insertAdjacentHTML('beforeend', res);
                                initMenuItemsAndBehavior();
                            });
                        }
                        else {
                            loaded = true;
                            initMenuItemsAndBehavior();
                            return $.Deferred().resolve().promise();
                        }
                    }
                    else {
                        onOpen && onOpen();
                        return $.Deferred().resolve().promise();
                    }
                };
                var openMenu = function () {
                    return loadMobileMenu()
                        .then(function () {
                        hamburgerMenuComponent.open();
                        menuContainerEl.classList.add("menu-is-open");
                        attachOnDocumentClick();
                        var firstLevelListEl = eXpress.html.querySelector(mobileMenuEl, ".o-navigation-mobile__first-level-navigation__button-list", true);
                        eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(firstLevelListEl);
                        firstLevelListEl.dataset.elementHeight = firstLevelListEl.style.height || '';
                    });
                };
                var resetMenu = function () {
                    containerEl.classList.remove("second-level-is-active");
                    containerEl.classList.remove("third-level-is-active");
                    userContainerEl.classList.remove("u-hide");
                    closeContainerEl.classList.remove("u-hide");
                    firstLevelMenuEls.forEach(function (firstLevelEl) {
                        firstLevelEl.classList.remove("u-hide");
                        var firstLevelMenuButtons = eXpress.html.querySelectorAll(firstLevelEl, ".o-navigation-mobile__first-level-navigation__button");
                        firstLevelMenuButtons.forEach(function (el) { return el.classList.remove("u-hide"); });
                    });
                    eXpress.html.querySelectorAll(containerEl, ".technical-mobile-navigation-second-level").forEach(function (el) {
                        if (!el.classList.contains("u-hide"))
                            el.classList.add("u-hide");
                    });
                    secondLevelMenuEls.forEach(function (secondLevelEl) {
                        if (!secondLevelEl.classList.contains("u-hide"))
                            secondLevelEl.classList.add("u-hide");
                        var menuSecondLevelContainerEls = eXpress.html.querySelectorAll(secondLevelEl, ".technical-mobile-navigation-container");
                        menuSecondLevelContainerEls.forEach(function (el) { return el.classList.remove("u-hide"); });
                        var thirdLevelEls = eXpress.html.querySelectorAll(secondLevelEl, ".technical-mobile-navigation-third-level");
                        thirdLevelEls.forEach(function (thirdLevelEl) {
                            if (!thirdLevelEl.classList.contains("u-hide"))
                                thirdLevelEl.classList.add("u-hide");
                        });
                    });
                };
                var hideOtherMenuItems = function (elem) {
                    if (elem.parentNode && elem.parentNode.hasChildNodes()) {
                        [].slice.call(elem.parentNode.children)
                            .forEach(function (el) {
                            var elm = el;
                            if (elem !== elm) {
                                elm.classList.toggle("u-hide");
                            }
                        });
                    }
                };
                var onFirstMenuItemClick = function (e) {
                    var _a;
                    if (handleHeaderLink(e.target))
                        return;
                    var firstLevelEl = e.currentTarget;
                    var secondLevelIndex = (_a = Number(firstLevelEl.dataset.index)) !== null && _a !== void 0 ? _a : -1;
                    var secondLevelEl = eXpress.html.querySelector(firstLevelEl, '.technical-mobile-navigation-second-level', false);
                    if (!secondLevelEl)
                        return;
                    firstLevelMenuSelected = eXpress.html.querySelector(firstLevelEl, ".technical-mobile-navigation-second-level") || undefined;
                    var prevClickedEl = eXpress.html.querySelector(mobileMenuEl, ".technical-clicked", false);
                    var firstLevelListEl = eXpress.html.querySelector(mobileMenuEl, ".o-navigation-mobile__first-level-navigation__button-list", true);
                    firstLevelListEl.style.height = prevClickedEl ? firstLevelListEl.dataset.elementHeight || "" : "100vh";
                    firstLevelListEl.scrollTop = 0;
                    if (firstLevelMenuSelected) {
                        if (!prevClickedEl) {
                            firstLevelEl.classList.add("technical-clicked");
                            firstLevelEl.dataset.offset = firstLevelEl.offsetTop + "";
                            var parent_1 = firstLevelEl.parentNode;
                            if (parent_1)
                                parent_1.dataset.offset = parent_1.offsetTop + "";
                        }
                        containerEl.classList.add("second-level-is-active");
                        containerEl.classList.remove("third-level-is-active");
                        userContainerEl.classList.toggle("u-hide");
                        closeContainerEl.classList.toggle("u-hide");
                        hideOtherMenuItems(firstLevelEl);
                        firstLevelMenuSelected.classList.toggle("u-hide");
                        var firstLevelMenuButton = eXpress.html.querySelector(firstLevelEl, ".o-navigation-mobile__first-level-navigation__button");
                        if (firstLevelMenuButton)
                            firstLevelMenuButton.classList.toggle("u-hide");
                        var secondLevelNavigationEl = eXpress.html.querySelector(firstLevelMenuSelected, ".technical-second-level");
                        if (secondLevelNavigationEl)
                            secondLevelNavigationEl.classList.remove("u-hide");
                        var secondLevelContainerEl = eXpress.html.querySelectorAll(firstLevelMenuSelected, ".technical-mobile-navigation-second-level-container");
                        secondLevelContainerEl.forEach(function (el) { return el.classList.remove("u-hide"); });
                        var menuItemsSecondLvl = eXpress.html.querySelector(firstLevelMenuSelected, '.o-navigation-mobile__second-level-navigation__button-list', false);
                        if (menuItemsSecondLvl && menuItemsSecondLvl.clientHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsSecondLvl);
                        else
                            firstLevelListEl.style.height = firstLevelListEl.dataset.elementHeight || '';
                    }
                    if (prevClickedEl) {
                        prevClickedEl.classList.remove("technical-clicked");
                        setScrollTop(prevClickedEl);
                        if (prevClickedEl.parentNode) {
                            setScrollTop(prevClickedEl.parentNode);
                        }
                    }
                    if (!firstLevelMenuSelected)
                        return;
                    var loadSecondLevelEl = eXpress.html.querySelector(secondLevelEl, '.technical-replace-level-loaded', false);
                    if (!loadSecondLevelEl || !loadSecondLevelEl.parentElement) {
                        var menuItemsSecondLvl = eXpress.html.querySelector(firstLevelMenuSelected, '.o-navigation-mobile__second-level-navigation__button-list', false);
                        if (menuItemsSecondLvl && menuItemsSecondLvl.clientHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsSecondLvl);
                        else
                            firstLevelListEl.style.height = firstLevelListEl.dataset.elementHeight || '';
                        return;
                    }
                    getMobileMenu(secondLevelIndex, -1).then(function (res) {
                        var frag = document.createRange().createContextualFragment(res);
                        secondLevelEl.replaceChild(frag, loadSecondLevelEl);
                        var secondLevelItems = eXpress.html.querySelectorAll(firstLevelEl, ".technical-mobile-navigation-second-level-container");
                        secondLevelMenuEls = secondLevelMenuEls.concat(secondLevelItems);
                        attachSecondMenuItemClick(secondLevelItems);
                        if (!firstLevelMenuSelected)
                            return;
                        var menuItemsSecondLvl = eXpress.html.querySelector(firstLevelMenuSelected, '.o-navigation-mobile__second-level-navigation__button-list', false);
                        if (menuItemsSecondLvl && menuItemsSecondLvl.clientHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsSecondLvl);
                        else
                            firstLevelListEl.style.height = firstLevelListEl.dataset.elementHeight || '';
                    });
                };
                var setScrollTop = function (el) {
                    var scrollPos = el.dataset.offset || "";
                    if (scrollPos && el.parentNode) {
                        var parent_2 = el.parentNode;
                        parent_2.scrollTop = parseInt(scrollPos, 10);
                        el.dataset.offset = "";
                    }
                };
                var onSecondMenuItemClick = function (e) {
                    var _a, _b;
                    if (handleHeaderLink(e.target))
                        return;
                    e.stopPropagation();
                    var secondLevelEl = e.currentTarget;
                    var thirdLevelDivEl = eXpress.html.querySelector(secondLevelEl, '.technical-mobile-navigation-third-level', false);
                    if (!thirdLevelDivEl)
                        return;
                    var thirdLevelEl = secondLevelEl.querySelector(".technical-mobile-navigation-third-level");
                    if (thirdLevelEl) {
                        containerEl.classList.toggle("third-level-is-active");
                        thirdLevelEl.classList.toggle("u-hide");
                        hideOtherMenuItems(secondLevelEl);
                        if (firstLevelMenuSelected) {
                            var secondeLevelNavigationEl = firstLevelMenuSelected.querySelector(".technical-second-level");
                            if (secondeLevelNavigationEl)
                                secondeLevelNavigationEl.classList.toggle("u-hide");
                        }
                        var thirdLevelContainerEl = secondLevelEl.querySelector(".technical-mobile-navigation-container");
                        if (thirdLevelContainerEl)
                            thirdLevelContainerEl.classList.toggle("u-hide");
                        var menuItemsThirdLvl = eXpress.html.querySelector(secondLevelEl, '.o-navigation-mobile__third-level-navigation__button-list', false);
                        if (menuItemsThirdLvl && menuItemsThirdLvl.offsetHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsThirdLvl);
                    }
                    var loadThridLevelEl = eXpress.html.querySelector(thirdLevelDivEl, '.technical-replace-level-loaded', false);
                    if (!loadThridLevelEl || !loadThridLevelEl.parentElement) {
                        var menuItemsThirdLvl = eXpress.html.querySelector(secondLevelEl, '.o-navigation-mobile__third-level-navigation__button-list', false);
                        if (menuItemsThirdLvl && menuItemsThirdLvl.offsetHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsThirdLvl);
                        return;
                    }
                    var secondLevelIndex = (_a = Number(secondLevelEl.closest('.technical-mobile-navigation-first-level-container').dataset.index)) !== null && _a !== void 0 ? _a : -1;
                    var thirdLevelIndex = (_b = Number(secondLevelEl.dataset.index)) !== null && _b !== void 0 ? _b : -1;
                    getMobileMenu(secondLevelIndex, thirdLevelIndex).then(function (res) {
                        var frag = document.createRange().createContextualFragment(res);
                        thirdLevelDivEl.replaceChild(frag, loadThridLevelEl);
                        var thirdLevelItems = eXpress.html.querySelectorAll(secondLevelEl, ".o-navigation-mobile__third-level-navigation__button-container");
                        thirdLevelMenuEls = thirdLevelMenuEls.concat(thirdLevelItems);
                        attachThirdMenuItemClick(thirdLevelItems);
                        var menuItemsThirdLvl = eXpress.html.querySelector(secondLevelEl, '.o-navigation-mobile__third-level-navigation__button-list', false);
                        if (menuItemsThirdLvl && menuItemsThirdLvl.offsetHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsThirdLvl);
                    });
                };
                var onThirdMenuItemClick = function (e) {
                    e.stopPropagation();
                };
                var handleHeaderLink = function (evTarget) {
                    if (evTarget) {
                        var target = evTarget;
                        if (target.nodeName.toLowerCase() === "a" || (target.parentNode && target.parentNode.nodeName.toLowerCase() === "a")) {
                            return true;
                        }
                    }
                    return false;
                };
                var attachCloseMenuClick = function (closeContainerEl) {
                    var closeButtonEl = eXpress.html.querySelector(closeContainerEl, ".m-navigation-overlay__close-icon");
                    if (closeButtonEl) {
                        onCloseClickDisposable = eXpress.utils.compositeDisposable([eXpress.html.addEventListener(closeContainerEl, "click", onCloseMenuClick)]);
                    }
                };
                var detachCloseMenuClick = function () { return onCloseClickDisposable && onCloseClickDisposable.dispose(); };
                var attachFirstMenuItemClick = function (firstLevelMenuEls) {
                    firstLevelMenuEls.forEach(function (e) { return eXpress.html.addEventListener(e, "click", onFirstMenuItemClick); });
                };
                var attachSecondMenuItemClick = function (secondLevelMenuEls) {
                    secondLevelMenuEls.forEach(function (e) { return eXpress.html.addEventListener(e, "click", onSecondMenuItemClick); });
                };
                var attachThirdMenuItemClick = function (thirdLevelMenuEls) {
                    thirdLevelMenuEls.forEach(function (e) { return eXpress.html.addEventListener(e, "click", onThirdMenuItemClick); });
                };
                var deInit = function () {
                    dispose();
                    closeMenu();
                };
                var dispose = function () {
                    hamburgerMenuComponent.dispose();
                    detachCloseMenuClick();
                    detachDocumentClick();
                    firstLevelMenuEls.forEach(function (e) { return e.removeEventListener("click", onFirstMenuItemClick); });
                    secondLevelMenuEls.forEach(function (e) { return e.removeEventListener("click", onSecondMenuItemClick); });
                    thirdLevelMenuEls.forEach(function (e) { return e.removeEventListener("click", onThirdMenuItemClick); });
                };
                return {
                    deInit: deInit
                };
            }
            main.initNavigationMobile = initNavigationMobile;
            function initNavigationMobileNew(placeholder, buttonEl, deps) {
                var _this = this;
                var onDocumentClickDisposable;
                var languageSelector;
                var menuCache = [];
                var getMobileMenu = deps.getMobileMenu, getIconsAsync = deps.getIconsAsync, onOpen = deps.onOpen, onClose = deps.onClose;
                var firstLevelDisposables = eXpress.utils.compositeDisposable([]);
                var secondLevelDisposables = eXpress.utils.compositeDisposable([]);
                var thirdLevelDisposables = eXpress.utils.compositeDisposable([]);
                var currentSecondLevelIndex = -1;
                var currentThirdLevelIndex = -1;
                var htmlEl = eXpress.html.querySelector(document, "html", true);
                var currentScope = window.context.scope;
                var bodyEl = eXpress.html.querySelector(document, "body", true);
                var onButtonClick = function () { return (placeholder.classList.contains("menu-is-open") ? closeMenu() : openMenu()); };
                var hamburgerMenuComponent = initHamburgerMenu(buttonEl, {
                    onButtonClick: onButtonClick,
                });
                var onDocumentClick = function (e) {
                    if (!e.target.closest("#technical-mobile-menu, .technical-mobile-navigation-hamburger-menu-button")) {
                        closeMenu();
                    }
                };
                var attachOnDocumentClick = function () {
                    return (onDocumentClickDisposable = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(document, 'click', onDocumentClick, true)
                    ]));
                };
                var detachDocumentClick = function () { return onDocumentClickDisposable && onDocumentClickDisposable.dispose(); };
                var closeMenu = function () {
                    eXpress.html.removeClass(htmlEl, "has-open-dialog u-no-scroll");
                    eXpress.html.removeClass(bodyEl, "u-no-scroll");
                    setCloseClasses();
                    detachDocumentClick();
                    if (onClose)
                        onClose();
                    currentSecondLevelIndex = -1;
                    currentThirdLevelIndex = -1;
                    disposeMenuDisposables();
                    return $.Deferred().resolve().promise();
                };
                var setCloseClasses = function () {
                    hamburgerMenuComponent.close();
                    placeholder.classList.remove("menu-is-open");
                    placeholder.classList.add("u-hide");
                };
                var loadIcons = function (urls) { return __awaiter(_this, void 0, void 0, function () {
                    var icons, uniqueUrls, res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                icons = {};
                                uniqueUrls = urls.filter(function (v, i) { return urls.indexOf(v) === i; });
                                return [4, getIconsAsync(uniqueUrls)];
                            case 1:
                                res = _a.sent();
                                res.forEach(function (icon) { return (icons[icon.url] = icon.svg); });
                                return [2, icons];
                        }
                    });
                }); };
                var attachFirstLevelMenuItemClick = function (firstLevelMenuEls) {
                    firstLevelMenuEls.forEach(function (e) {
                        if (firstLevelDisposables && firstLevelDisposables.add) {
                            firstLevelDisposables.add([eXpress.html.addEventListener(e, "click", function (e) {
                                    var clickedEl = e.currentTarget;
                                    currentSecondLevelIndex = parseInt(clickedEl.dataset.index || "-1", 10);
                                    firstLevelDisposables.dispose();
                                    onSubLevelMenuItemClick(e).then(function (r) { return initSecondLevelMenuItemsAndBehavior(r); });
                                })]);
                        }
                    });
                };
                var attachSecondLevelMenuItemClick = function (secondLevelMenuEls) {
                    secondLevelMenuEls.forEach(function (e) {
                        if (secondLevelDisposables && secondLevelDisposables.add) {
                            secondLevelDisposables.add([
                                eXpress.html.addEventListener(e, "click", function (e) {
                                    var clickedEl = e.currentTarget;
                                    currentThirdLevelIndex = parseInt(clickedEl.dataset.index || "-1", 10);
                                    secondLevelDisposables.dispose();
                                    onSubLevelMenuItemClick(e).then(function (r) { return initThirdLevelMenuItemsAndBehavior(r); });
                                })
                            ]);
                        }
                    });
                };
                var onSubLevelMenuItemClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
                    var cachedMenu, res, newMenuEl;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                cachedMenu = getCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                                if (!cachedMenu) return [3, 1];
                                placeholder.innerHTML = cachedMenu.content;
                                return [2, placeholder];
                            case 1: return [4, getMobileMenu(currentSecondLevelIndex, currentThirdLevelIndex)];
                            case 2:
                                res = _a.sent();
                                newMenuEl = eXpress.html.htmlToElement(res);
                                placeholder.innerHTML = newMenuEl.innerHTML;
                                return [2, placeholder];
                        }
                    });
                }); };
                var initSubLevelMenuItemsAndBehavior = function (menuEl, options) {
                    var onBack = options.onBack, disposables = options.disposables, initPrevLevelMenu = options.initPrevLevelMenu, attachMenuItemClick = options.attachMenuItemClick;
                    var topSecondaryEl = eXpress.html.querySelector(menuEl, ".technical-navigation-secondary-top", true);
                    var backButtonEl = eXpress.html.querySelector(topSecondaryEl, "button", true);
                    if (backButtonEl) {
                        if (disposables && disposables.add) {
                            disposables.add([eXpress.html.addEventListener(backButtonEl, "click", function () {
                                    onBack();
                                    var cachedMenu = getCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                                    if (cachedMenu) {
                                        placeholder.innerHTML = cachedMenu.content;
                                        initPrevLevelMenu(placeholder);
                                    }
                                })]);
                        }
                    }
                    loadIconsFromCmsAndCache(menuEl);
                    if (attachMenuItemClick) {
                        var menuItemEls = eXpress.html.querySelectorAll(menuEl, "button.technical-navigation-action");
                        if (menuItemEls && menuItemEls.length > 0) {
                            attachMenuItemClick(menuItemEls);
                        }
                    }
                    setMaxHeightOnListElement(placeholder);
                };
                var initSecondLevelMenuItemsAndBehavior = function (menuEl) {
                    initSubLevelMenuItemsAndBehavior(menuEl, {
                        level: "second",
                        onBack: function () {
                            currentSecondLevelIndex = -1;
                        },
                        disposables: secondLevelDisposables,
                        initPrevLevelMenu: initMenuItemsAndBehavior,
                        attachMenuItemClick: attachSecondLevelMenuItemClick,
                    });
                };
                var initThirdLevelMenuItemsAndBehavior = function (menuEl) {
                    initSubLevelMenuItemsAndBehavior(menuEl, {
                        level: "third",
                        onBack: function () {
                            currentThirdLevelIndex = -1;
                        },
                        disposables: thirdLevelDisposables,
                        initPrevLevelMenu: initSecondLevelMenuItemsAndBehavior,
                    });
                };
                var setMaxHeightOnListElement = function (menuEl) {
                    var topEl = eXpress.html.querySelector(menuEl, ".technical-navigation-top", true);
                    var navigationListEl = eXpress.html.querySelector(menuEl, ".technical-navigation-list", true);
                    var topElHeight = eXpress.html.getHeightWithMargins(topEl);
                    navigationListEl.style.maxHeight = "calc(100% - " + topElHeight + "px)";
                };
                var initMenuItemsAndBehavior = function (menuEl) {
                    if (languageSelector)
                        languageSelector.dispose();
                    var languageSelectorEl = eXpress.html.querySelector(menuEl, ".technical-language-selector");
                    if (languageSelectorEl) {
                        languageSelector = main.initLanguageSelector(languageSelectorEl);
                    }
                    loadIconsFromCmsAndCache(menuEl);
                    var menuItemEls = eXpress.html.querySelectorAll(menuEl, "button.technical-navigation-action");
                    menuItemEls && attachFirstLevelMenuItemClick(menuItemEls);
                };
                var loadMobileMenu = function () {
                    var cachedMenu = getCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                    if (cachedMenu) {
                        placeholder.innerHTML = cachedMenu.content;
                        initMenuItemsAndBehavior(placeholder);
                        return $.Deferred().resolve().promise();
                    }
                    else {
                        return getMobileMenu().then(function (res) {
                            var newMenuEl = eXpress.html.htmlToElement(res);
                            placeholder.innerHTML = newMenuEl.innerHTML;
                            initMenuItemsAndBehavior(placeholder);
                            onOpen && onOpen();
                        });
                    }
                };
                var loadIconsFromCmsAndCache = function (menuEl) {
                    var iconButtonEls = eXpress.html.querySelectorAll(menuEl, ".technical-icon").filter(function (el) {
                        if (!el.getAttribute("data-icon-svg"))
                            return false;
                        var iconFileEl = eXpress.html.querySelector(el, ".technical-icon-file");
                        if (!iconFileEl)
                            return false;
                        var svgAlreadyLoaded = eXpress.html.querySelector(iconFileEl, "svg");
                        return !svgAlreadyLoaded;
                    });
                    if (iconButtonEls.length > 0) {
                        loadIcons(iconButtonEls.map(function (el) { return el.getAttribute("data-icon-svg"); })).then(function (res) {
                            iconButtonEls.forEach(function (el) {
                                var icon = res[el.getAttribute("data-icon-svg")];
                                if (icon) {
                                    var iconFile = eXpress.html.querySelector(el, ".technical-icon-file");
                                    iconFile && iconFile.insertAdjacentHTML("beforeend", icon);
                                }
                            });
                            updateCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex, menuEl.innerHTML);
                        });
                    }
                    else {
                        updateCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex, menuEl.innerHTML);
                    }
                };
                var updateCachedMenu = function (secondLevelIndex, thirdLevelIndex, content) {
                    if (eXpress.utils.isLocalStorageSupported()) {
                        var localStorageCache = eXpress.utils.getLocalStorageItem("mobileMenuCache", currentScope) || [];
                        var existingCacheIndex = localStorageCache.findIndex(function (m) { return m.secondLevelIndex === secondLevelIndex && m.thirdLevelIndex === thirdLevelIndex; });
                        if (existingCacheIndex !== -1) {
                            localStorageCache[existingCacheIndex].content = content;
                        }
                        else {
                            localStorageCache.push({ secondLevelIndex: secondLevelIndex, thirdLevelIndex: thirdLevelIndex, content: content });
                        }
                        var expiryDate = new Date();
                        expiryDate.setDate(expiryDate.getDate() + 1);
                        eXpress.utils.setLocalStorageItem("mobileMenuCache", localStorageCache, currentScope, expiryDate);
                    }
                    else {
                        menuCache.push({
                            secondLevelIndex: currentSecondLevelIndex,
                            thirdLevelIndex: currentThirdLevelIndex,
                            content: content,
                        });
                    }
                };
                var getCachedMenu = function (secondLevelIndex, thirdLevelIndex) {
                    if (eXpress.utils.isLocalStorageSupported()) {
                        var localStorageCache = eXpress.utils.getLocalStorageItem("mobileMenuCache", currentScope) || [];
                        if (!localStorageCache || localStorageCache.length === 0)
                            return undefined;
                        return localStorageCache.find(function (m) { return m.secondLevelIndex === secondLevelIndex && m.thirdLevelIndex === thirdLevelIndex; });
                    }
                    return menuCache.find(function (m) { return m.secondLevelIndex === currentSecondLevelIndex && m.thirdLevelIndex === currentThirdLevelIndex; });
                };
                var openMenu = function () {
                    return loadMobileMenu().then(function (res) {
                        eXpress.html.addClass(htmlEl, "has-open-dialog u-no-scroll");
                        eXpress.html.addClass(bodyEl, "u-no-scroll");
                        hamburgerMenuComponent.open();
                        placeholder.classList.add("menu-is-open");
                        placeholder.classList.remove("u-hide");
                        attachOnDocumentClick();
                        setMaxHeightOnListElement(placeholder);
                    });
                };
                var deInit = function () {
                    dispose();
                    closeMenu();
                };
                var disposeMenuDisposables = function () {
                    firstLevelDisposables && firstLevelDisposables.dispose();
                    secondLevelDisposables && secondLevelDisposables.dispose();
                    thirdLevelDisposables && thirdLevelDisposables.dispose();
                };
                var dispose = function () {
                    hamburgerMenuComponent.dispose();
                    languageSelector && languageSelector.deInit();
                    disposeMenuDisposables();
                    detachDocumentClick();
                };
                return {
                    deInit: deInit,
                    setCloseClasses: setCloseClasses,
                };
            }
            main.initNavigationMobileNew = initNavigationMobileNew;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createNewsletterSubscribe(containerEl, deps) {
                var formEl = eXpress.html.querySelector(containerEl, 'form', true);
                var emailEl = eXpress.html.querySelector(formEl, '.technical-subscribe-email', true);
                var emptyGuid = '00000000-0000-0000-0000-000000000000';
                var appId = containerEl.dataset.appid || emptyGuid;
                var posId = containerEl.dataset.posid || emptyGuid;
                var lang = containerEl.dataset.lang || "";
                var email = eXpress.utils.getCookie('LastUsedEmail');
                if (email)
                    emailEl.value = email;
                var subscribeAsync = deps.subscribeAsync;
                var source = formEl.getAttribute("source") || formEl.getAttribute("data-source") || undefined;
                !source && (source = emailEl.dataset.sourceid || (formEl.getAttribute("data-source") || undefined));
                var subscribeForm = components.main.initForm(formEl, {
                    onSubmitForm: function () {
                        return subscribeAsync(emailEl.value, appId, posId, lang, source)
                            .then(function () {
                            eXpress.html.addClass(containerEl, "m-newsletter--success");
                            eXpress.html.addClass(formEl, 'm-newsletter__form');
                        }, function (e) {
                            eXpress.html.removeClass(containerEl, "m-newsletter--success");
                            eXpress.html.removeClass(formEl, 'm-newsletter__form');
                        });
                    },
                    buttonSelector: ".technical-subscribe-button",
                    submitOnEnter: true
                });
                return { dispose: subscribeForm.dispose };
            }
            main.createNewsletterSubscribe = createNewsletterSubscribe;
            function createNewsletterUnsubscribe(containerEl, deps) {
                var formEl = eXpress.html.querySelector(containerEl, 'form', true);
                var successMessageEl = eXpress.html.querySelector(containerEl, '.technical-success-message', false);
                var errorMessageEl = eXpress.html.querySelector(containerEl, '.technical-error-message', false);
                var emailEl = eXpress.html.querySelector(formEl, '.technical-unsubscribe-mail', false);
                var checkBoxEl = eXpress.html.querySelector(formEl, '#newsletter', false);
                var toggleSubscribeAsync = deps.toggleSubscribeAsync;
                var emptyGuid = '00000000-0000-0000-0000-000000000000';
                var appId = containerEl.dataset.appid || emptyGuid;
                var posId = containerEl.dataset.posid || emptyGuid;
                var lang = containerEl.dataset.lang || window.context.language;
                var email = eXpress.utils.getCookie('LastUsedEmail');
                if (email && emailEl)
                    emailEl.value = email;
                var showSuccessMessage = function () {
                    successMessageEl && eXpress.html.removeClass(successMessageEl, "u-hide");
                    errorMessageEl && eXpress.html.addClass(errorMessageEl, "u-hide");
                    eXpress.html.hide(formEl);
                    eXpress.html.addClass(containerEl, "m-newsletter--success");
                };
                var showErrorMessage = function () {
                    successMessageEl && eXpress.html.addClass(successMessageEl, "u-hide");
                    errorMessageEl && eXpress.html.removeClass(errorMessageEl, "u-hide");
                    eXpress.html.show(formEl);
                };
                emailEl && emailEl.setAttribute('required', 'required');
                if (checkBoxEl)
                    checkBoxEl.setAttribute('required', 'required');
                var unsubscribeForm = components.main.initForm(formEl, {
                    onSubmitForm: function () {
                        return toggleSubscribeAsync(eXpress.utils.getParameter("personid"), emailEl ? emailEl.value : '', appId, posId, lang, 'NewsletterUnsubscribe', false, false)
                            .then(function (_) { return showSuccessMessage(); })
                            .catch(function (_) { return showErrorMessage(); });
                    },
                    buttonSelector: ".technical-unsubscribe-button"
                });
                return { dispose: unsubscribeForm.dispose };
            }
            main.createNewsletterUnsubscribe = createNewsletterUnsubscribe;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createNotificationTile(containerEl, markNotificationAsRead) {
                var statusEl = eXpress.html.querySelector(containerEl, ".m-notification-tile__read-status", true);
                var checkBoxEl = eXpress.html.querySelector(statusEl, ".a-form-input__input", true);
                var linkEl = eXpress.html.querySelector(containerEl, ".m-notification-tile__text__link", false);
                var remove = function () { return eXpress.html.remove(containerEl); };
                var returnElements = [];
                var onTileClick = function (e) {
                    e.preventDefault();
                    checkBoxEl.disabled = true;
                    checkBoxEl.removeEventListener('click', onTileClick);
                    markNotificationAsRead(checkBoxEl.value)
                        .then(function () { return containerEl.classList.add("o-notifications-center__notification-tile--removed"); })
                        .then(function () { return remove(); });
                };
                checkBoxEl.addEventListener('click', onTileClick);
                linkEl && linkEl.addEventListener('click', function () {
                    var orderNumber = linkEl.dataset.ordernumber || '';
                    var pvc = linkEl.dataset.sku || '';
                    var orderStatus = linkEl.dataset.orderstatus || '';
                    eXpress.analytics.trackOrderStatusEvent("ClickOnOrderItemNotificationLink", { orderNumber: orderNumber, pvc: pvc, orderStatus: orderStatus });
                });
                if (linkEl)
                    returnElements.push(linkEl);
                returnElements.push(checkBoxEl);
                return returnElements;
            }
            main.createNotificationTile = createNotificationTile;
            function createNotificationCenter(containerEl, deps) {
                var onDocumentClickDisposable;
                var onMarkedAllAsReadDisposable;
                var keyboardNavigatorDisposables;
                var domParser = new DOMParser();
                var loaded = false;
                var getNotifications = deps.getNotifications, isMobile = deps.isMobile, markNotificationsAsRead = deps.markNotificationsAsRead, onClose = deps.onClose, onOpen = deps.onOpen;
                var buttonEl = eXpress.html.querySelector(containerEl, '.o-icon-navigation__notifications-center__icon', true);
                var notificationBellCountEl = eXpress.html.querySelector(buttonEl, '.o-icon-navigation__count ', true);
                var menuEl = eXpress.html.querySelector(containerEl, '.o-icon-navigation__notifications-center-menu', true);
                var overLayEl = eXpress.html.querySelector(menuEl, '.technical-notification-center-overlay', true);
                var contentEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__content', true);
                var closeButtonEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__close-container', true);
                var markAllAsReadButton;
                var setOverLayClass = function () {
                    var _a;
                    var mobile = isMobile();
                    (_a = overLayEl.classList).remove.apply(_a, ["m-navigation-overlay__mobile-view", "m-navigation-overlay__desktop-view"]);
                    overLayEl.classList.add(mobile ? "m-navigation-overlay__mobile-view" : "m-navigation-overlay__desktop-view");
                };
                var setNotificationCount = function (amount, markAllAsReadButton) {
                    if (amount > 0) {
                        notificationBellCountEl.innerHTML = amount.toString();
                        if (markAllAsReadButton)
                            markAllAsReadButton.innerHTML += "(".concat(amount, ")");
                        eXpress.html.show(notificationBellCountEl);
                    }
                    else {
                        notificationBellCountEl.innerHTML = "";
                        eXpress.html.hide(notificationBellCountEl);
                    }
                };
                var getTiles = function () { return eXpress.html.querySelectorAll(contentEl, '.m-notification-tile'); };
                var onMarkedAsReadSingle = function (ids) { return markNotificationsAsRead(ids.split(';'))
                    .then(function () { return loadNotifications(true); }); };
                var onMarkedAllAsRead = function () {
                    if (markAllAsReadButton) {
                        markAllAsReadButton.disabled = true;
                        markAllAsReadButton.classList.add("a-button--disabled");
                    }
                    detachMarkAllAsReadClick();
                    var ids = getTiles()
                        .map(function (el) { return eXpress.html.querySelector(el, '.a-form-input__input', true)
                        .value.split(";"); })
                        .reduce(function (a, b) { return a.concat(b); }, []);
                    if (ids && ids.length > 0) {
                        return markNotificationsAsRead(ids)
                            .then(function (res) {
                            if (res)
                                loadNotifications(true);
                        });
                    }
                };
                var loadNotifications = function (reload) {
                    if (reload === void 0) { reload = false; }
                    if (loaded && !reload)
                        return $.Deferred().resolve().promise();
                    return getNotifications()
                        .then(function (res) {
                        if (res) {
                            var parsed = domParser.parseFromString(res, "text/html").documentElement;
                            var notificationCenterEl = eXpress.html.querySelector(parsed, ".o-notifications-center__container", true);
                            contentEl.innerHTML = "";
                            contentEl.insertAdjacentElement('beforeend', notificationCenterEl);
                            markAllAsReadButton = eXpress.html.querySelector(contentEl, '.o-notifications-center__mark-as-read', true);
                            var tiles = getTiles();
                            var dropdownItemEls_1 = [];
                            if (tiles.length > 0) {
                                markAllAsReadButton.classList.remove("a-button--disabled");
                                tiles.forEach(function (el) { return dropdownItemEls_1.push.apply(dropdownItemEls_1, createNotificationTile(el, onMarkedAsReadSingle)); });
                                attachMarkAllAsReadClick(markAllAsReadButton);
                            }
                            if (tiles.length === 0) {
                                markAllAsReadButton.classList.add("a-button--disabled");
                            }
                            setNotificationCount(tiles.length);
                            if (!isMobile()) {
                                keyboardNavigatorDisposables && keyboardNavigatorDisposables.dispose();
                                keyboardNavigatorDisposables = eXpress.utils.compositeDisposable([
                                    main.createDropDownKeyboardNavigator(containerEl, {
                                        onEnter: onButtonClick,
                                        onEscape: onCloseIconClick,
                                        onBeforeArrowDown: function () {
                                            if (!menuEl.classList.contains("menu-is-open"))
                                                openMenu();
                                        },
                                        dropdownItemEls: dropdownItemEls_1,
                                    }),
                                ]);
                            }
                            loaded = true;
                        }
                    });
                };
                var onNotificationCenterOpen = function () {
                    setOverLayClass();
                    return loadNotifications();
                };
                var closeMenu = function () {
                    menuEl.classList.remove("menu-is-open");
                    detachDocumentClick();
                    onClose && onClose();
                    return $.Deferred().resolve().promise();
                };
                var openMenu = function () {
                    eXpress.analytics.trackOrderStatusEvent("ClickOnNotificationIcon", {});
                    return onNotificationCenterOpen()
                        .then(function () {
                        onOpen && onOpen();
                        attachOnDocumentClick();
                        menuEl.classList.add("menu-is-open");
                    });
                };
                var onCloseIconClick = function (e) {
                    e.stopPropagation();
                    closeMenu();
                };
                var onButtonClick = function () {
                    return menuEl.classList.contains("menu-is-open")
                        ? closeMenu()
                        : openMenu();
                };
                var onDocumentClick = function (e) {
                    if (!e.target.closest(".o-icon-navigation__notifications-center-menu, .o-icon-navigation__notifications-center__icon")) {
                        closeMenu();
                    }
                };
                var attachOnDocumentClick = function () {
                    return (onDocumentClickDisposable = eXpress.html.addEventListener(document, 'click', onDocumentClick, true));
                };
                var detachDocumentClick = function () { return onDocumentClickDisposable && onDocumentClickDisposable.dispose(); };
                var attachMarkAllAsReadClick = function (buttonEl) {
                    return (onMarkedAllAsReadDisposable = eXpress.html.addEventListener(buttonEl, 'click', onMarkedAllAsRead));
                };
                var detachMarkAllAsReadClick = function () { return onMarkedAllAsReadDisposable && onMarkedAllAsReadDisposable.dispose(); };
                var button = main.createClickableElement(buttonEl, onButtonClick);
                var eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(closeButtonEl, 'click', onCloseIconClick),
                    eXpress.html.addEventListener(window, 'resize', setOverLayClass),
                ]);
                if (!isMobile()) {
                    keyboardNavigatorDisposables = eXpress.utils.compositeDisposable([
                        main.createDropDownKeyboardNavigator(containerEl, {
                            onEnter: onButtonClick,
                            onEscape: onCloseIconClick,
                            onBeforeArrowDown: function () {
                                if (!menuEl.classList.contains("menu-is-open"))
                                    openMenu();
                            },
                            dropdownItemEls: [],
                        }),
                    ]);
                }
                return {
                    dispose: function () {
                        eventDisposables.dispose();
                        button.dispose();
                        detachDocumentClick();
                        detachMarkAllAsReadClick();
                        closeMenu();
                    }
                };
            }
            main.createNotificationCenter = createNotificationCenter;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            var PageLogStyle;
            (function (PageLogStyle) {
                PageLogStyle[PageLogStyle["Error"] = 0] = "Error";
                PageLogStyle[PageLogStyle["WarningBlue"] = 1] = "WarningBlue";
                PageLogStyle[PageLogStyle["WarningOrange"] = 2] = "WarningOrange";
                PageLogStyle[PageLogStyle["Success"] = 3] = "Success";
            })(PageLogStyle = main.PageLogStyle || (main.PageLogStyle = {}));
            function createPageLog(containerEl) {
                var iconEl = eXpress.html.querySelector(containerEl, '.technical-top-message-icon', true);
                var descriptionEl = eXpress.html.querySelector(containerEl, '.technical-top-message-description', true);
                var getClassesByPrefix = function (el, prefix) {
                    var classes = [].slice.call(el.classList);
                    return classes.filter(function (c) { return c.indexOf(prefix) > -1; });
                };
                var LOG_PREFIX = "m-page-log--";
                var ICON_BG_CIRCLE_PREFIX = "v2-a-icon--background-circle-";
                var getLogIconAndType = function (logStyle) {
                    switch (logStyle) {
                        case PageLogStyle.Error:
                            return {
                                type: "m-page-log--error",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "red",
                                icon: "/svg/close-symbol.svg#close-symbol",
                                iconTestId: "close-symbol"
                            };
                        case PageLogStyle.Success:
                            return {
                                type: "m-page-log--validation",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "green",
                                icon: "/svg/checkmark-symbol.svg#checkmark-symbol",
                                iconTestId: "checkmark-symbol"
                            };
                        case PageLogStyle.WarningBlue:
                            return {
                                type: "m-page-log--info-blue",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "blue",
                                icon: "/svg/info-symbol.svg#info-symbol",
                                iconTestId: "info-symbol"
                            };
                        case PageLogStyle.WarningOrange:
                            return {
                                type: "m-page-log--info-orange",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "orange",
                                icon: "/svg/info-symbol.svg#info-symbol",
                                iconTestId: "info-symbol"
                            };
                        default:
                            return {
                                type: "",
                                iconBackgroundCircle: "",
                                icon: "",
                                iconTestId: ""
                            };
                    }
                };
                var show = function () { return containerEl.classList.remove("u-hide"); };
                var hide = function () { return containerEl.classList.add("u-hide"); };
                var scrollTo = function () { return window.scrollTo({ top: getOffsetTop(containerEl), behavior: 'smooth' }); };
                var getOffsetTop = function (offsetElemet) {
                    var offsetTop = 0;
                    var elem = offsetElemet;
                    do {
                        if (elem.offsetTop > 0) {
                            offsetTop += elem.offsetTop;
                        }
                        elem = elem.offsetParent;
                    } while (elem);
                    return offsetTop;
                };
                var updateMessageAndStyle = function (logStyle, description, overrideScrollTo) {
                    var _a, _b;
                    if (overrideScrollTo === void 0) { overrideScrollTo = false; }
                    var disableScroll = description === descriptionEl.innerHTML;
                    (_a = containerEl.classList).remove.apply(_a, getClassesByPrefix(containerEl, LOG_PREFIX));
                    (_b = iconEl.classList).remove.apply(_b, getClassesByPrefix(iconEl, ICON_BG_CIRCLE_PREFIX));
                    var _c = getLogIconAndType(logStyle), type = _c.type, iconBackgroundCircle = _c.iconBackgroundCircle, icon = _c.icon, iconTestId = _c.iconTestId;
                    containerEl.classList.add(type);
                    iconEl.classList.add(iconBackgroundCircle);
                    iconEl.dataset.test = iconTestId;
                    var useEl = eXpress.html.querySelector(iconEl, "use", true);
                    if (useEl.getAttribute("href") !== icon)
                        useEl.setAttribute("href", icon);
                    descriptionEl.innerHTML = description;
                    show();
                    if (!disableScroll || overrideScrollTo)
                        scrollTo();
                };
                return {
                    updateMessageAndStyle: updateMessageAndStyle,
                    hide: hide,
                    scrollTo: scrollTo
                };
            }
            main.createPageLog = createPageLog;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            window.addEventListener('load', function () {
                var scrollToTopEl = eXpress.html.querySelector(document, ".technical-scroll-to-top", false);
                if (!scrollToTopEl)
                    return;
                var progressPathEl = scrollToTopEl && eXpress.html.querySelector(scrollToTopEl, ".technical-progress-path", true);
                var init = function () {
                    var pathLength = 0;
                    var ticking = false;
                    var wobblerEl = eXpress.html.querySelector(document, ".technical-wobbler", false);
                    var stickyCtaButtonEl = eXpress.html.querySelector(document, ".technical-mobile-cta-button", false);
                    var footerEl = eXpress.html.querySelector(document, "footer", false);
                    if (wobblerEl && stickyCtaButtonEl && eXpress.html.isElementVisible(stickyCtaButtonEl)) {
                        scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler--has-sticky-button");
                    }
                    else {
                        if (wobblerEl)
                            scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler");
                        if (stickyCtaButtonEl && eXpress.html.isElementVisible(stickyCtaButtonEl))
                            scrollToTopEl.classList.add("m-scroll-to-top--has-sticky-button");
                    }
                    pathLength = progressPathEl.getTotalLength();
                    progressPathEl.style.strokeDasharray = "".concat(pathLength, " ").concat(pathLength);
                    progressPathEl.style.strokeDashoffset = pathLength + "";
                    var updateProgress = function () {
                        var scroll = window.scrollY;
                        var height = document.documentElement.scrollHeight - window.innerHeight;
                        var progress = pathLength - (scroll * pathLength) / height;
                        progressPathEl.style.strokeDashoffset = progress + "";
                    };
                    function handleScroll() {
                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                updateProgress();
                                scrollToTopEl && scrollToTopEl.classList.toggle("m-scroll-to-top--active-progress", window.scrollY > 50);
                                ticking = false;
                            });
                            ticking = true;
                        }
                    }
                    var isIOS = function () {
                        var iosQuirkPresent = function () {
                            var audio = new Audio();
                            audio.volume = 0.5;
                            return audio.volume === 1;
                        };
                        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                        var isAppleDevice = navigator.userAgent.indexOf("Macintosh") !== 0;
                        var isTouchScreen = navigator.maxTouchPoints >= 1;
                        return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
                    };
                    var setBottomStyle = function () {
                        if (stickyCtaButtonEl && eXpress.html.isElementVisible(stickyCtaButtonEl)) {
                            if (footerEl)
                                footerEl.style.marginBottom = 10 + stickyCtaButtonEl.clientHeight + "px";
                            scrollToTopEl.style.bottom =
                                10 +
                                    stickyCtaButtonEl.clientHeight +
                                    (stickyCtaButtonEl.parentElement
                                        ? parseFloat(window.getComputedStyle(stickyCtaButtonEl.parentElement, null).getPropertyValue("padding-bottom"))
                                        : 0) +
                                    "px";
                        }
                        else {
                            scrollToTopEl.style.bottom = "";
                            if (footerEl)
                                footerEl.style.marginBottom = "";
                        }
                    };
                    var onResize = function () {
                        if (!stickyCtaButtonEl)
                            return;
                        if (eXpress.html.isElementVisible(stickyCtaButtonEl)) {
                            if (wobblerEl)
                                scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler--has-sticky-button");
                            else
                                scrollToTopEl.classList.add("m-scroll-to-top--has-sticky-button");
                        }
                        else {
                            if (wobblerEl) {
                                scrollToTopEl.classList.remove("m-scroll-to-top--has-wobbler--has-sticky-button");
                                scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler");
                            }
                            else {
                                scrollToTopEl.classList.remove("m-scroll-to-top--has-sticky-button");
                            }
                        }
                        setBottomStyle();
                    };
                    window.addEventListener("scroll", function () {
                        handleScroll();
                    });
                    var debouncedResize = eXpress.utils.debounce(onResize, 100);
                    window.addEventListener("resize", debouncedResize);
                    scrollToTopEl.addEventListener("click", function () {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        if (isIOS())
                            eXpress.utils.debounce(function () {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }, 100);
                    });
                    updateProgress();
                    setBottomStyle();
                };
                init();
            });
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initSearchBar(desktopSearchBarContainer, mobileSearchBarContainer, autoCompleteSearch, onOpen, onClose) {
                var initAutoComplete = function (buttonEl, inputEl) {
                    var buttonDisabledClass = "a-button--disabled";
                    var form = inputEl.parentElement;
                    if (buttonEl)
                        buttonEl.classList.add(buttonDisabledClass);
                    var renderTextWithHighlights = function (item, currentSearchterm) {
                        currentSearchterm = currentSearchterm.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var re = new RegExp("(" + currentSearchterm.split(' ').join('|') + ")", "gi");
                        return item.value.replace(re, "<b>$1</b>");
                    };
                    buttonEl.onkeyup = function (ev) {
                        if (ev.key === "Enter") {
                            if (inputEl && inputEl.value && validateInput(inputEl)) {
                                form.submit();
                            }
                            else {
                                inputEl.focus();
                            }
                        }
                    };
                    inputEl.onkeyup = function () {
                        if (buttonEl) {
                            if (inputEl && inputEl.value)
                                buttonEl.classList.remove(buttonDisabledClass);
                            else
                                buttonEl.classList.add(buttonDisabledClass);
                        }
                    };
                    form.onsubmit = function (e) {
                        if (!inputEl || !inputEl.value || !validateInput(inputEl)) {
                            e.preventDefault();
                            return;
                        }
                        inputEl.value = inputEl.value.replace(/[<>]+/g, '');
                    };
                    return main.createTextInputWithAutoComplete(inputEl, {
                        onSelect: function () { onClose && onClose(); form.submit(); },
                        autoCompleteSearch: function (searchterm) {
                            if (validateInput(inputEl, searchterm))
                                return autoCompleteSearch(searchterm).then(function (res) { return res.map(function (item) { return ({ value: item, label: item }); }); });
                            return $.Deferred();
                        },
                        onOpen: onOpen,
                        onClose: onClose,
                        renderTextContent: renderTextWithHighlights,
                        containerClass: 'm-autocomplete autocomplete-suggestions m-search-bar__autocomplete',
                        containerInsertPosition: 'afterend',
                    });
                };
                var validateInput = function (inputEl, searchTerm) {
                    return eXpress.utils.isValidTextWithoutAngleBrackets(searchTerm ? searchTerm : inputEl.value);
                };
                var initMobileSearchBar = function (containerEl) {
                    var inputEl = eXpress.html.querySelector(containerEl, ".m-search-bar__input", true);
                    var buttonEl = eXpress.html.querySelector(containerEl, ".icon-search_thin", true);
                    var autoComplete = initAutoComplete(buttonEl, inputEl);
                    var onSearchTooltipOpen = function () { return inputEl.focus(); };
                    var form = inputEl.parentElement;
                    form.onsubmit = function (e) {
                        if (!inputEl || !inputEl.value || !validateInput(inputEl)) {
                            e.preventDefault();
                            return;
                        }
                        inputEl.value = inputEl.value.replace(/[<>]+/g, '');
                    };
                    var overlayComponent = components.main.initTooltip({
                        buttonEl: containerEl.previousElementSibling,
                        containerEl: containerEl,
                        onOpen: onSearchTooltipOpen,
                        openClass: "menu-is-open",
                        tooltipSelector: ".o-icon-navigation__search-bar",
                        toggleIconSelector: ".icon-search_thin"
                    });
                    return {
                        dispose: function () {
                            overlayComponent.dispose();
                            autoComplete.dispose();
                        }
                    };
                };
                var desktopSearchBar = initAutoComplete(eXpress.html.querySelector(desktopSearchBarContainer, '.icon-search_thin', true), eXpress.html.querySelector(desktopSearchBarContainer, '.m-search-bar__input', true));
                var mobileSearchBar = initMobileSearchBar(mobileSearchBarContainer);
                return {
                    dispose: function () {
                        mobileSearchBar.dispose();
                        desktopSearchBar.dispose();
                    }
                };
            }
            main.initSearchBar = initSearchBar;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            eXpress.html.querySelectorAll(document, ".skeleton-loading img").forEach(function (img) {
                var removeSkeleton = function () {
                    var parent = eXpress.html.getParentWithClassName(img, "skeleton-loading");
                    if (parent)
                        parent.classList.remove("skeleton-loading");
                };
                if (img.complete) {
                    removeSkeleton();
                }
                else {
                    img.addEventListener("load", function () { removeSkeleton(); });
                }
            });
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createExternalInlineLogin(containerEl, deps, authenticatedCallback) {
                if (authenticatedCallback === void 0) { authenticatedCallback = null; }
                var googleLoginButtonEl = eXpress.html.querySelector(containerEl, ".technical-button-google-login", false);
                var googleAppid = googleLoginButtonEl && googleLoginButtonEl.dataset.appid || undefined;
                var facebookLoginButtonEl = eXpress.html.querySelector(containerEl, ".technical-button-facebook-login", false);
                var onOrderFlow = deps.onOrderFlow;
                var loginUserAtSmartPhoto = function (uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow, scope, idToken) {
                    var loginUserAtSmartPhotoPromise = $.ajax({
                        url: '/ajaxxhr/Login/LoginUserAtSmartPhoto',
                        type: 'POST',
                        global: false,
                        contentType: 'application/json; charset=utf-8',
                        data: '{' +
                            '"userId": "' + uid + '", ' +
                            '"accessToken": "' + accessToken + '", ' +
                            '"expire": "' + expire + '", ' +
                            '"mediastorePartnerType": "' + mediaStorePartnerType + '", ' +
                            '"newEmail": "' + newEmail + '", ' +
                            '"skipLogin": "' + skipLogin + '", ' +
                            '"onOrderFlow": "' + onOrderFlow + '", ' +
                            '"async": "' + async + '", ' +
                            '"scope": "' + scope + '", ' +
                            '"idToken": "' + idToken +
                            '}',
                        dataType: 'json',
                    })
                        .then(function (res) { return res; });
                    return eXpress.utils.showLoadingDialog(loginUserAtSmartPhotoPromise)
                        .then(function (res) { return handleExternalLoginResult(res, mediaStorePartnerType, async, onOrderFlow, undefined, undefined, undefined, undefined, uid, accessToken); });
                };
                var handleExternalLoginResult = function (response, mediaStorePartnerType, async, onOrderFlow, accountId, tempAccountId, showConfirmationBeforeRedirect, loginNotCorrect, uid, accessToken, idToken, scope, expire) {
                    if (accountId === void 0) { accountId = ""; }
                    if (tempAccountId === void 0) { tempAccountId = ""; }
                    if (showConfirmationBeforeRedirect === void 0) { showConfirmationBeforeRedirect = false; }
                    if (loginNotCorrect === void 0) { loginNotCorrect = false; }
                    if (uid === void 0) { uid = ""; }
                    if (accessToken === void 0) { accessToken = ""; }
                    if (idToken === void 0) { idToken = ""; }
                    if (scope === void 0) { scope = ""; }
                    if (expire === void 0) { expire = 0; }
                    var ssoConfirmationDialog = function (email, mediaStorePartnerType, okFunction) {
                    };
                    var loginUserAtSmartPhotoResponse = undefined;
                    var loginResult = undefined;
                    if (isLoginUserAtSmartPhotoResponse(response))
                        loginUserAtSmartPhotoResponse = response;
                    else
                        loginResult = response;
                    var asyncSuccess = true;
                    if (async) {
                        if (loginResult && loginResult.success == 'true') {
                            asyncSuccess = false;
                        }
                    }
                    if (async && asyncSuccess && loginUserAtSmartPhotoResponse) {
                        loginResult = loginUserAtSmartPhotoResponse.loginResult;
                    }
                    if (asyncSuccess && loginResult && loginResult.success == 'true') {
                        if (async) {
                            if (authenticatedCallback)
                                authenticatedCallback();
                        }
                        else {
                            var okFunction = void 0;
                            if (loginResult.redirectUrl) {
                                var url_1 = loginResult.redirectUrl;
                                okFunction = window.setTimeout(function () {
                                    window.location.replace(url_1);
                                }, 0);
                            }
                            if (showConfirmationBeforeRedirect)
                                ssoConfirmationDialog(loginResult.Email, mediaStorePartnerType, okFunction);
                            else
                                okFunction();
                        }
                    }
                    else if (loginResult) {
                        if (!loginResult.AccountId && accountId)
                            loginResult.AccountId = accountId;
                        if (!loginResult.tempAccountId && tempAccountId)
                            loginResult.tempAccountId = tempAccountId;
                        handleLoginFailed(loginResult, mediaStorePartnerType, loginNotCorrect, async, onOrderFlow, mediaStorePartnerType, uid, accessToken, idToken, scope, expire);
                    }
                };
                var handleLoginFailed = function (loginResult, mediaStorePartnerType, loginNotCorrect, async, onOrderFlow, mediaStorePartnerLabel, uid, accessToken, idToken, scope, expire, skipLogin) {
                    if (uid === void 0) { uid = ""; }
                    if (accessToken === void 0) { accessToken = ""; }
                    if (idToken === void 0) { idToken = ""; }
                    if (scope === void 0) { scope = ""; }
                    if (expire === void 0) { expire = 0; }
                    if (skipLogin === void 0) { skipLogin = false; }
                    var alreadyTriedNewEmail = false;
                    var popUpCase = loginResult.PopUpCase;
                    var otherEmailDialogTriggered = 0;
                    var accountInOtherDomainCalled = 0;
                    switch (popUpCase) {
                        case "AccountBlocked":
                            deps.popups.accountBlockedDialog();
                            break;
                        case "AskPassword":
                            deps.popups.askPasswordDialog(loginResult.AccountId, loginResult.tempAccountId, mediaStorePartnerType, loginNotCorrect, alreadyTriedNewEmail, async, onOrderFlow, mediaStorePartnerLabel, handleExternalLoginResult);
                            break;
                        case "AlreadyLoggedIn":
                            deps.popups.allReadyLoggedInDialog();
                            break;
                        case "FatalErrorMessage":
                            deps.popups.fatalErrorDialog(mediaStorePartnerLabel);
                            break;
                        case "ConfirmEmail":
                            deps.popups.confirmEmailDialog(loginResult.Email, loginResult.tempAccountId, mediaStorePartnerType, mediaStorePartnerLabel);
                            break;
                        case "OtherEmail":
                            deps.popups.otherEmailDialog(loginResult.AccountId, uid, accessToken, expire, otherEmailDialogTriggered > 0, skipLogin, async, onOrderFlow, mediaStorePartnerLabel, function (uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow) { return loginUserAtSmartPhoto(uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow, scope, idToken); }, mediaStorePartnerType);
                            otherEmailDialogTriggered++;
                            break;
                        case "FbIdAlreadyConnected":
                            deps.popups.fbIdAlreadyConnected(mediaStorePartnerLabel);
                            break;
                        case "AccountInOtherDomain":
                            deps.popups.accountInOtherDomainDialog(loginResult.AccountId, uid, accessToken, expire, accountInOtherDomainCalled > 0, skipLogin, async, onOrderFlow, function (uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow) { return loginUserAtSmartPhoto(uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow, scope, idToken); }, mediaStorePartnerType);
                            accountInOtherDomainCalled++;
                            break;
                        case "ShowNewsletter":
                            deps.popups.showNewsletterPopup(loginResult.PersonId, loginResult.redirectUrl);
                            break;
                        default:
                            deps.popups.generalErrorDialog(mediaStorePartnerLabel);
                            break;
                    }
                };
                var isLoginUserAtSmartPhotoResponse = function (response) {
                    if (!response) {
                        return false;
                    }
                    return response.loginResult;
                };
                var init = function () {
                    if (googleLoginButtonEl && googleAppid) {
                        components.main.createGoogleLogin(googleLoginButtonEl, onOrderFlow, {
                            appId: googleAppid,
                            handleExternalLoginResult: function (response, mediaStorePartnerType, async, onOrderFlow, idToken, scope) {
                                if (idToken === void 0) { idToken = ""; }
                                if (scope === void 0) { scope = ""; }
                                return handleExternalLoginResult(response, mediaStorePartnerType, async, onOrderFlow, undefined, undefined, undefined, undefined, undefined, idToken, scope, undefined);
                            },
                        });
                    }
                    if (facebookLoginButtonEl) {
                        components.main.createFacebookLoginButton(facebookLoginButtonEl, onOrderFlow, {
                            handleExternalLoginResult: function (response, mediaStorePartnerType, async, onOrderFlow, userId, accessToken, scope, expiresIn) {
                                return handleExternalLoginResult(response, mediaStorePartnerType, async, onOrderFlow, undefined, undefined, false, false, userId, accessToken, undefined, scope, expiresIn);
                            },
                        });
                    }
                };
                init();
            }
            main.createExternalInlineLogin = createExternalInlineLogin;
            function createStandardInlineRegister(containerEl, formEl, deps, redirectUrl, authenticatedCallback) {
                if (redirectUrl === void 0) { redirectUrl = null; }
                if (authenticatedCallback === void 0) { authenticatedCallback = null; }
                var newsletterEl = eXpress.html.querySelector(containerEl, ".technical-newsletter", true);
                var personalMessageEl = eXpress.html.querySelector(containerEl, ".technical-personal-message", true);
                var register = function (email, password, newsletter, personalMessage) {
                    return $.ajax({
                        url: "/ajaxxhr/Login/Registration",
                        type: "POST",
                        data: {
                            Email: email,
                            Password: password,
                            Newsletter: newsletter,
                            PersonalMessage: personalMessage,
                            redirectUrl: redirectUrl
                        }
                    })
                        .then(function (res) { return res; });
                };
                var handleRegisterResult = function (result, setError) {
                    if (result.success && result.redirectUrl) {
                        window.history.replaceState({}, document.title, result.redirectUrl);
                        window.location.replace(result.redirectUrl + "?success=true");
                    }
                    if (!result.success && result.message) {
                        setError('password', result.message);
                    }
                };
                var onSubmitRegisterForm = function (formData) {
                    return eXpress.utils.showLoadingDialog(register(formData["email"], formData["password"], newsletterEl.checked, personalMessageEl.checked)
                        .then(function (res) {
                        handleRegisterResult(res, setError);
                    }));
                };
                var setError = function (name, error) { return registerForm.setErrors(false, { name: name, error: error }); };
                var registerForm = components.main.initForm(formEl, {
                    onSubmitForm: onSubmitRegisterForm,
                    buttonSelector: ".technical-register-button"
                });
                var init = function () {
                    createExternalInlineLogin(containerEl, deps, authenticatedCallback);
                };
                init();
            }
            main.createStandardInlineRegister = createStandardInlineRegister;
            function createStandardInlineLogin(containerEl, formEl, deps, redirectUrl, authenticatedCallback) {
                if (redirectUrl === void 0) { redirectUrl = null; }
                if (authenticatedCallback === void 0) { authenticatedCallback = null; }
                var closeButton = eXpress.html.querySelector(containerEl, '.technical-login-close', true);
                var forgotPasswordButton = eXpress.html.querySelector(containerEl, '.technical-login-forgot-button', true);
                var login = function (email, password) {
                    return $.ajax({
                        url: "/ajaxxhr/Login/NormalLogin",
                        type: "POST",
                        data: {
                            Email: email,
                            PassWord: eXpress.utils.stringToBase64(password),
                            redirectUrl: redirectUrl
                        }
                    })
                        .then(function (res) { return res; });
                };
                var forgotPassword = function (email) {
                    return $.ajax({
                        url: "/ajaxxhr/Login/ForgotPassword",
                        type: "POST",
                        data: {
                            email: email
                        }
                    }).then(function (res) { return res; });
                };
                var handleLoginResult = function (result, setError) {
                    if (!result.isNotAuthenticated && !result.blockingErrorMsg) {
                        if (result.redirectUrl) {
                            window.history.replaceState({}, document.title, result.redirectUrl);
                            window.location.replace(result.redirectUrl + "?success=true");
                        }
                        else if (authenticatedCallback)
                            authenticatedCallback();
                    }
                    else {
                        if (result.blockingErrorMsg && deps.showTopMessage)
                            deps.showTopMessage(components.main.PageLogStyle.Error, result.blockingErrorMsg);
                        if (result.isNotAuthenticated && !result.blockingErrorMsg)
                            setError('password', result.errorMsg ? result.errorMsg : 'Something went wrong');
                    }
                };
                var onSubmitLoginForm = function (formData) {
                    return eXpress.utils.showLoadingDialog(login(formData["email"], formData["password"])
                        .then(function (res) {
                        handleLoginResult(res, setError);
                    }));
                };
                var setError = function (name, error) { return loginForm.setErrors(false, { name: name, error: error }); };
                var loginForm = components.main.initForm(formEl, {
                    onSubmitForm: onSubmitLoginForm,
                    buttonSelector: ".technical-login-button"
                });
                var closeLogin = function () {
                    if (deps.hideTopMessage)
                        deps.hideTopMessage();
                    if (deps.close)
                        deps.close();
                    else
                        containerEl.classList.add('u-hide');
                };
                var eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(closeButton, 'click', closeLogin),
                    eXpress.html.addEventListener(forgotPasswordButton, 'click', deps.showForgotPasswordPopup)
                ]);
                var hideCloseButton = function () {
                    closeButton.classList.add('u-hide');
                };
                var disableInput = function (inputName) {
                    loginForm.disableInput(inputName);
                };
                var init = function () {
                    createExternalInlineLogin(containerEl, deps, authenticatedCallback);
                };
                init();
                return {
                    dispose: function () {
                        eventDisposables.dispose();
                    },
                    forgotPassword: forgotPassword,
                    hideCloseButton: hideCloseButton,
                    disableInput: disableInput
                };
            }
            main.createStandardInlineLogin = createStandardInlineLogin;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function CreateTabs(container) {
                var tabsCollectionContainer = eXpress.html.querySelector(container, '.m-tabs', true);
                var tabHideClass = tabsCollectionContainer.dataset.hideclass || 'u-hide';
                var init = function () {
                    updateTab(tabHideClass, location.hash.substring(1));
                    addEventListenerToTabs();
                };
                var addEventListenerToTabs = function () {
                    var tabEls = eXpress.html.querySelectorAll(tabsCollectionContainer, '.m-tabs__input');
                    for (var i = 0; i < tabEls.length; i++)
                        tabEls[i].addEventListener('change', function (e) { return updateTab(tabHideClass, e.target.dataset.url); });
                    window.addEventListener('hashchange', function () { return updateTab(tabHideClass, location.hash.substring(1), false); });
                };
                var updateTab = function (hideclass, hash, pushNewHash) {
                    if (pushNewHash === void 0) { pushNewHash = true; }
                    var tabToSelect = hash ? eXpress.html.querySelector(tabsCollectionContainer, "input[data-url=\"".concat(hash, "\"]"), false) : undefined;
                    var tabEls = eXpress.html.querySelectorAll(tabsCollectionContainer, '.m-tabs__input');
                    var tabContentEls = eXpress.html.querySelectorAll(tabsCollectionContainer, '.m-tabs__content');
                    for (var z = 0; z < tabEls.length; z++) {
                        tabEls[z].checked = (tabEls[z] === tabToSelect || (!tabToSelect && z === 0));
                        tabContentEls[z].classList.toggle(hideclass || 'u-hide', !tabEls[z].checked);
                        if (tabEls[z].checked && pushNewHash && tabToSelect)
                            window.history.pushState({}, document.title, "#".concat(hash));
                    }
                };
                init();
            }
            main.CreateTabs = CreateTabs;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            var _this = this;
            var AddressAutocompletionType;
            (function (AddressAutocompletionType) {
                AddressAutocompletionType[AddressAutocompletionType["None"] = 0] = "None";
                AddressAutocompletionType[AddressAutocompletionType["Address"] = 1] = "Address";
                AddressAutocompletionType[AddressAutocompletionType["City"] = 2] = "City";
                AddressAutocompletionType[AddressAutocompletionType["Street"] = 3] = "Street";
                AddressAutocompletionType[AddressAutocompletionType["StreetNumber"] = 4] = "StreetNumber";
            })(AddressAutocompletionType = main.AddressAutocompletionType || (main.AddressAutocompletionType = {}));
            main.autocompleteAddressAsync = function (street, number, zip, city, countryCode, autocompletionType, maxNrOfSuggestions) { return __awaiter(_this, void 0, void 0, function () {
                var url, body, response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (street.length < 5)
                                return [2, undefined];
                            if (zip.length <= 0 || city.length <= 0)
                                return [2, undefined];
                            if (["BEL", "NLD", "CHE"].indexOf(countryCode) == -1)
                                return [2, undefined];
                            url = "/apicore/delivery/autocompleteaddress";
                            body = {
                                street: street,
                                number: number,
                                zip: zip,
                                city: city,
                                countryCode: countryCode,
                                autocompletionType: autocompletionType,
                                maxNrOfSuggestions: maxNrOfSuggestions,
                            };
                            return [4, fetch(url, {
                                    method: 'POST',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(body),
                                })];
                        case 1:
                            response = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, response.json()];
                        case 3: return [2, _a.sent()];
                        case 4:
                            e_1 = _a.sent();
                            return [2, undefined];
                        case 5:
                            ;
                            return [2];
                    }
                });
            }); };
            main.validateAddressAsync = function (street, nr, zip, city, country, deps) { return __awaiter(_this, void 0, void 0, function () {
                var serverfetch, server;
                return __generator(this, function (_a) {
                    if (street.length < 3) {
                        return [2, undefined];
                    }
                    serverfetch = function (obj) {
                        return __awaiter(this, void 0, void 0, function () {
                            var nlUrl, rawResponse, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        nlUrl = '/ajaxxhr/Delivery/ValidateAddress';
                                        return [4, fetch(nlUrl, {
                                                method: 'POST',
                                                headers: {
                                                    'Accept': 'application/json',
                                                    'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify(obj),
                                            }).catch(function (res) {
                                                return deps && deps.logError ? deps.logError(res.toString(), nlUrl, "w3wp").catch(function (_) { return undefined; }) : undefined;
                                            })];
                                    case 1:
                                        rawResponse = _b.sent();
                                        if (!rawResponse) return [3, 3];
                                        return [4, rawResponse.json()];
                                    case 2:
                                        _a = _b.sent();
                                        return [3, 4];
                                    case 3:
                                        _a = undefined;
                                        _b.label = 4;
                                    case 4: return [2, _a];
                                }
                            });
                        });
                    };
                    server = function () {
                        if (zip.length <= 0 || city.length <= 0)
                            return undefined;
                        var obj = {
                            street: street,
                            nr: nr,
                            zip: zip,
                            city: city,
                            country: country
                        };
                        return serverfetch(obj).then(function (content) {
                            if (content) {
                                var result = {
                                    street: content.street,
                                    nr: content.nr,
                                    zip: content.zip,
                                    city: content.city
                                };
                                return result;
                            }
                            else
                                return undefined;
                        }).catch(function () {
                            return undefined;
                        });
                    };
                    if (country === "BEL" || country === "NLD" || country === 'CHE')
                        return [2, server()];
                    else
                        return [2, undefined];
                    return [2];
                });
            }); };
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initTooltip(options) {
                var buttonEl = options.buttonEl, containerEl = options.containerEl, onOpen = options.onOpen, onClose = options.onClose, iconCloseSelector = options.iconCloseSelector, openClass = options.openClass, tooltipSelector = options.tooltipSelector, toggleIconSelector = options.toggleIconSelector, _a = options.useCapture, useCapture = _a === void 0 ? false : _a;
                var closeIconEl = containerEl.querySelector(iconCloseSelector || ".icon-close");
                var onCloseIconClick = function (e) {
                    e.stopPropagation();
                    closeToolTip();
                };
                var closeToolTip = function () {
                    containerEl.classList.remove(openClass || "is-tooltip-open");
                    if (onClose)
                        onClose();
                    document.removeEventListener("click", onDocumentClick);
                };
                var openToolTip = function () {
                    containerEl.classList.add(openClass || "is-tooltip-open");
                    if (onOpen)
                        onOpen(containerEl);
                    document.addEventListener("click", onDocumentClick, { capture: useCapture });
                };
                var onButtonClick = function (e) {
                    containerEl.classList.contains(openClass || "is-tooltip-open")
                        ? closeToolTip()
                        : openToolTip();
                };
                var onDocumentClick = function (e) {
                    var selector = (tooltipSelector || ".technical-price-tooltip") + ", " + (toggleIconSelector || ".technical-price-info-icon");
                    if (!e.target.closest(selector)) {
                        closeToolTip();
                    }
                };
                if (closeIconEl)
                    closeIconEl.addEventListener("click", onCloseIconClick);
                buttonEl.addEventListener("click", onButtonClick);
                var dispose = function () {
                    buttonEl.removeEventListener("click", onButtonClick);
                    document.removeEventListener("click", onDocumentClick);
                    if (closeIconEl)
                        closeIconEl.removeEventListener("click", onCloseIconClick);
                };
                return {
                    dispose: dispose,
                    closeToolTip: closeToolTip
                };
            }
            main.initTooltip = initTooltip;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
